(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cape-hatteras-session-map"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-session-map]';
    const cleanups = new WeakMap();
    const openLayersCssUrl = 'https://cdn.jsdelivr.net/npm/ol@10.9.0/ol.css';
    const openLayersScriptUrl = 'https://cdn.jsdelivr.net/npm/ol@10.9.0/dist/ol.js';
    let openLayersPromise;
    const sportLabels = {
      kite: 'Kite',
      surf: 'Surf',
      foil: 'Foil'
    };
    const levelLabels = {
      all: 'All levels',
      beginner: 'Beginner',
      intermediate: 'Intermediate',
      advanced: 'Advanced'
    };
    const sportKeys = ['kite', 'surf', 'foil'];
    const validWinds = new Set(['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW']);
    const validLevels = new Set(['all', 'beginner', 'intermediate', 'advanced']);

    const escapeHTML = (value) => String(value).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[character]);

    const toTitleList = (items, labels = {}) => {
      if (!items || !items.length) return 'Local check';
      return items.map((item) => labels[item] || item).join(', ');
    };

    const normalizeList = (value) => {
      if (Array.isArray(value)) return value.map((item) => String(item).trim()).filter(Boolean);
      if (value == null || value === '') return [];
      return String(value).split(',').map((item) => item.trim()).filter(Boolean);
    };

    const normalizeSpot = (rawSpot) => {
      const sportDetails = {};

      sportKeys.forEach((sport) => {
        if (rawSpot[`${sport}_enabled`] !== true) return;

        const winds = normalizeList(rawSpot[`${sport}_ideal_winds`])
          .map((wind) => wind.toUpperCase())
          .filter((wind) => validWinds.has(wind));
        const rawLevel = String(rawSpot[`${sport}_skill_level`] || '').toLowerCase();

        sportDetails[sport] = {
          winds,
          level: validLevels.has(rawLevel) ? rawLevel : null
        };
      });

      const sports = Object.keys(sportDetails);
      const latitude = Number(rawSpot.latitude);
      const longitude = Number(rawSpot.longitude);

      return {
        id: String(rawSpot.handle || ''),
        name: String(rawSpot.name || ''),
        region: String(rawSpot.town_area || ''),
        summary: String(rawSpot.description || ''),
        lat: latitude,
        lon: longitude,
        googleMapsUrl: String(rawSpot.google_maps_url || ''),
        imageUrl: String(rawSpot.image_url || ''),
        imageAlt: String(rawSpot.image_alt || ''),
        sportDetails,
        sports,
        referenceLinks: normalizeList(rawSpot.reference_links),
        proTip: String(rawSpot.real_pro_tip || ''),
        proName: String(rawSpot.real_pro_name || ''),
        sortOrder: Number(rawSpot.sort_order) || 0,
        active: rawSpot.active !== false
      };
    };

    const renderSportConditions = (spot) => {
      return spot.sports.map((sport) => {
        const details = spot.sportDetails[sport];
        const windText = toTitleList(details.winds);
        const levelText = levelLabels[details.level] || 'Local check';

        return `
          <div class="session-map__condition-row">
            <span class="session-map__condition-sport session-map__condition-sport--${sport}">${escapeHTML(sportLabels[sport])}</span>
            <span><strong>Wind</strong>${escapeHTML(windText)}</span>
            <span><strong>Level</strong>${escapeHTML(levelText)}</span>
          </div>
        `;
      }).join('');
    };

    const getReferenceLabel = (url, index) => {
      try {
        const hostname = new URL(url).hostname.replace(/^www\./, '');
        if (hostname.includes('youtube.com') || hostname.includes('youtu.be')) return 'Watch video';
        if (hostname.includes('surfline.com')) return 'Surf forecast';
        if (hostname.includes('ikitesurf.com')) return 'Wind forecast';
        if (hostname.includes('surfchex.com')) return 'Live camera';
        if (hostname.includes('nps.gov')) return 'Access information';
        if (hostname.includes('ncdot.gov')) return 'Ferry information';
      } catch (error) {
        return `Reference ${index + 1}`;
      }

      return `Reference ${index + 1}`;
    };

    const externalLinkIcon = '<svg class="session-map__external-icon" aria-hidden="true" focusable="false" viewBox="0 0 16 16" width="16" height="16"><path d="M4 12 12 4M4 4h8v8" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    const renderReferenceLinks = (links) => {
      if (!links.length) return '';

      return `
        <div class="session-map__references">
          <p class="session-map__detail-label">Helpful links</p>
          <ul>
            ${links.map((url, index) => `
              <li><a href="${escapeHTML(url)}" target="_blank" rel="noopener">${escapeHTML(getReferenceLabel(url, index))}${externalLinkIcon}<span class="session-map__sr"> (opens in a new tab)</span></a></li>
            `).join('')}
          </ul>
        </div>
      `;
    };

    const renderSportBadges = (items) => {
      if (!items || !items.length) return '';

      return items.map((sport) => {
        const sportClass = ['kite', 'surf', 'foil'].includes(sport) ? sport : 'kite';
        return `<span class="session-map__sport-badge session-map__sport-badge--${sportClass}">${escapeHTML(sportLabels[sport] || sport)}</span>`;
      }).join('');
    };

    const renderSportStrip = (items) => {
      if (!items || !items.length) return '';

      const segments = items.map((sport) => {
        const sportClass = ['kite', 'surf', 'foil'].includes(sport) ? sport : 'kite';
        return `<span class="session-map__sport-strip-segment--${sportClass}"></span>`;
      }).join('');

      return `<span class="session-map__sport-strip" aria-hidden="true">${segments}</span>`;
    };

    const getPrimarySport = (spot) => {
      return spot.sports.find((sport) => ['kite', 'surf', 'foil'].includes(sport)) || 'kite';
    };

    const loadOpenLayers = () => {
      if (window.ol) return Promise.resolve(window.ol);
      if (openLayersPromise) return openLayersPromise;

      openLayersPromise = new Promise((resolve, reject) => {
        if (!document.querySelector('[data-session-map-ol-css]')) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = openLayersCssUrl;
          link.dataset.sessionMapOlCss = 'true';
          document.head.append(link);
        }

        const existingScript = document.querySelector('[data-session-map-ol-script]');
        if (existingScript) {
          existingScript.addEventListener('load', () => resolve(window.ol), { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = openLayersScriptUrl;
        script.async = true;
        script.dataset.sessionMapOlScript = 'true';
        script.addEventListener('load', () => resolve(window.ol), { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.append(script);
      });

      return openLayersPromise;
    };

    const initSessionMap = (root) => {
      if (root.dataset.sessionMapReady === 'true') return;
      root.dataset.sessionMapReady = 'true';

      const dataEl = root.querySelector('[data-session-map-data]');
      const mapEl = root.querySelector('[data-session-map-ol]');
      const listEl = root.querySelector('[data-session-map-list]');
      const countEl = root.querySelector('[data-session-map-count]');
      const detailEl = root.querySelector('[data-session-map-detail]');
      const searchEl = root.querySelector('[data-session-map-search]');
      const clearEl = root.querySelector('[data-session-map-clear]');
      const selectEls = root.querySelectorAll('[data-session-map-select]');
      const toolbarEl = root.querySelector('.session-map__toolbar');
      const filtersEl = root.querySelector('.session-map__filters');
      const utilityEl = root.querySelector('.session-map__utility');
      const filterFooterEl = root.querySelector('[data-session-map-filter-footer]');
      const filtersToggle = root.querySelector('[data-session-map-filters-toggle]');
      const guidanceToggle = root.querySelector('[data-session-map-guidance-toggle]');
      const guidanceContent = root.querySelector('.session-map__guidance-content');
      const exploreEl = root.querySelector('[data-session-map-explore]');
      const sheetEl = root.querySelector('[data-session-map-sheet]');
      const panelEl = root.querySelector('.session-map__panel');
      const workspaceEl = root.querySelector('.session-map__workspace');
      const mobileQuery = window.matchMedia('(max-width: 620px)');
      const lifecycle = new AbortController();

      if (!dataEl || !mapEl || !listEl || !countEl || !detailEl) return;

      let rawSpots;
      try {
        rawSpots = JSON.parse(dataEl.textContent);
      } catch (error) {
        root.dataset.sessionMapError = 'invalid-data';
        return;
      }
      if (!Array.isArray(rawSpots)) {
        root.dataset.sessionMapError = 'invalid-data';
        return;
      }

      const spots = rawSpots
        .map(normalizeSpot)
        .filter((spot) => spot.active && spot.id && spot.name && spot.region && spot.summary && spot.sports.length && Number.isFinite(spot.lat) && Number.isFinite(spot.lon))
        .sort((spotA, spotB) => spotA.sortOrder - spotB.sortOrder || spotA.name.localeCompare(spotB.name))
        .map((spot) => ({ ...spot, primarySport: getPrimarySport(spot) }));

      const state = {
        sport: 'all',
        wind: 'all',
        level: 'all',
        query: '',
        activeId: spots[0] ? spots[0].id : null,
        detailHidden: false,
        detailExpanded: false
      };

      const pinButtons = new Map();
      let map;
      let activeLabelEl;
      let activeLabelTextEl;
      let activeLabelOverlay;
      let mapResizeObserver;
      let revealMapTimer;
      let listReturnFocus;

      const setFiltersOpen = (open, restoreFocus = false) => {
        filtersEl.hidden = mobileQuery.matches && !open;
        filtersToggle.setAttribute('aria-expanded', String(open));
        if (restoreFocus) filtersToggle.focus({ preventScroll: true });
      };

      const restoreList = () => {
        workspaceEl.prepend(panelEl);
        exploreEl.setAttribute('aria-expanded', 'false');
        listReturnFocus?.focus({ preventScroll: true });
        listReturnFocus = null;
      };

      const closeList = (focusTarget = exploreEl) => {
        if (!sheetEl.open) return;
        listReturnFocus = focusTarget;
        sheetEl.close();
        restoreList();
      };

      const openList = () => {
        if (!mobileQuery.matches || sheetEl.open) return;
        setFiltersOpen(false);
        sheetEl.append(panelEl);
        sheetEl.showModal();
        exploreEl.setAttribute('aria-expanded', 'true');
        sheetEl.querySelector('[data-session-map-sheet-close]').focus({ preventScroll: true });
      };

      const syncMobileLayout = () => {
        const mobile = mobileQuery.matches;
        const focusedEl = document.activeElement;
        const focusWasInFilters = filtersEl.contains(focusedEl);
        const focusWasInList = panelEl.contains(focusedEl);
        const focusWasInGuidance = guidanceContent.contains(focusedEl);
        closeList(mobile ? exploreEl : searchEl);
        root.toggleAttribute('data-session-map-mobile', mobile);
        if (mobile) {
          toolbarEl.prepend(utilityEl);
          filterFooterEl.prepend(clearEl);
        } else {
          toolbarEl.prepend(filtersEl);
          utilityEl.insertBefore(clearEl, filtersToggle);
        }
        guidanceContent.hidden = mobile;
        guidanceToggle.setAttribute('aria-expanded', 'false');
        setFiltersOpen(false);
        if (mobile && focusWasInFilters) filtersToggle.focus({ preventScroll: true });
        if (mobile && focusWasInList) exploreEl.focus({ preventScroll: true });
        if (mobile && focusWasInGuidance) guidanceToggle.focus({ preventScroll: true });
        if (!mobile && [filtersToggle, guidanceToggle, exploreEl].includes(focusedEl)) searchEl.focus({ preventScroll: true });
        mapEl.parentElement.inert = mobile && state.detailExpanded;
        window.requestAnimationFrame(() => {
          if (lifecycle.signal.aborted) return;
          map?.updateSize();
          if (mobile) focusMapOnSpot(spots.find((spot) => spot.id === state.activeId));
        });
      };

      const bindSwipe = (handle, direction, action) => {
        let start;
        let ignoreClick = false;
        handle.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.button !== 0) return;
          ignoreClick = false;
          start = { x: event.clientX, y: event.clientY, id: event.pointerId };
          handle.setPointerCapture(event.pointerId);
        });
        handle.addEventListener('pointerup', (event) => {
          if (!start || start.id !== event.pointerId) return;
          const distance = (event.clientY - start.y) * direction;
          if (distance > 40 && distance > Math.abs(event.clientX - start.x)) {
            ignoreClick = true;
            action();
          }
          start = null;
        });
        handle.addEventListener('pointercancel', () => { start = null; });
        handle.addEventListener('click', (event) => {
          if (!ignoreClick || event.detail === 0) return;
          event.preventDefault();
          event.stopPropagation();
          ignoreClick = false;
        });
      };

      bindSwipe(exploreEl, -1, openList);
      bindSwipe(root.querySelector('[data-session-map-sheet-close]'), 1, () => closeList());
      sheetEl.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeList();
      });
      mobileQuery.addEventListener('change', syncMobileLayout, { signal: lifecycle.signal });
      cleanups.set(root, () => {
        closeList(null);
        lifecycle.abort();
        window.clearTimeout(revealMapTimer);
        mapResizeObserver?.disconnect();
        map?.dispose();
      });

      const getDisplaySport = (spot) => state.sport === 'all' ? spot.primarySport : state.sport;

      const syncActiveLabel = (spot) => {
        if (!activeLabelEl || !activeLabelTextEl || !activeLabelOverlay || !window.ol?.proj) return;

        const pinButton = spot ? pinButtons.get(spot.id) : null;
        const isVisible = Boolean(
          spot &&
          pinButton &&
          !pinButton.classList.contains('is-muted') &&
          !state.detailHidden
        );

        activeLabelEl.classList.toggle('is-hidden', !isVisible);
        if (!isVisible) {
          activeLabelOverlay.setPosition(undefined);
          return;
        }

        activeLabelTextEl.textContent = spot.name;
        activeLabelEl.dataset.sport = getDisplaySport(spot);
        activeLabelOverlay.setPosition(window.ol.proj.fromLonLat([spot.lon, spot.lat]));
      };

      const getFilteredSpots = () => spots.filter((spot) => {
        const candidateSports = state.sport === 'all'
          ? spot.sports
          : spot.sports.filter((sport) => sport === state.sport);
        const conditionsMatch = candidateSports.some((sport) => {
          const details = spot.sportDetails[sport];
          const windMatch = state.wind === 'all' || details.winds.includes(state.wind);
          const levelMatch = state.level === 'all' || details.level === 'all' || details.level === state.level;
          return windMatch && levelMatch;
        });
        const query = state.query.trim().toLowerCase();
        const queryMatch = !query || `${spot.name} ${spot.region} ${spot.summary} ${spot.proTip} ${spot.proName}`.toLowerCase().includes(query);
        return conditionsMatch && queryMatch;
      });

      const syncFilters = () => {
        const count = ['sport', 'wind', 'level'].filter((key) => state[key] !== 'all').length;
        root.querySelector('[data-session-map-filter-count]').textContent = count ? `(${count})` : '';
        root.querySelectorAll('[data-session-map-filter]').forEach((button) => {
          const filter = button.dataset.sessionMapFilter;
          const active = state[filter] === button.dataset.value;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        selectEls.forEach((select) => {
          const filter = select.dataset.sessionMapSelect;
          select.value = state[filter] || 'all';
        });
      };

      const renderDetail = (spot) => {
        syncActiveLabel(spot);
        mapEl.parentElement.inert = mobileQuery.matches && state.detailExpanded && !state.detailHidden;

        if (!spot) {
          detailEl.classList.remove('is-hidden');
          detailEl.classList.remove('is-expanded');
          detailEl.innerHTML = '<p class="session-map__empty">Adjust the filters to find a matching spot.</p>';
          return;
        }

        if (state.detailHidden) {
          detailEl.classList.add('is-hidden');
          detailEl.classList.remove('is-expanded');
          detailEl.innerHTML = '';
          return;
        }

        detailEl.classList.remove('is-hidden');
        detailEl.classList.toggle('is-expanded', state.detailExpanded);

        const coordinateMapHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${spot.lat},${spot.lon}`)}`;
        const mapHref = spot.googleMapsUrl || coordinateMapHref;
        const displaySport = getDisplaySport(spot);
        const displayDetails = spot.sportDetails[displaySport];
        const windText = toTitleList(displayDetails?.winds);
        const levelText = levelLabels[displayDetails?.level] || 'Local check';
        const kickerMarkup = `<p class="session-map__detail-kicker session-map__detail-kicker--${displaySport}">${escapeHTML(spot.region)} · ${escapeHTML(levelText)}</p>`;
        const detailImageSrc = spot.imageUrl;
        const imageMarkup = state.detailExpanded && detailImageSrc ? `
          <div class="session-map__detail-media">
            <img src="${escapeHTML(detailImageSrc)}" alt="${escapeHTML(spot.imageAlt)}" loading="lazy">
          </div>
        ` : '';
        const proTipMarkup = state.detailExpanded && spot.proTip ? `
          <blockquote class="session-map__pro-tip">
            <p class="session-map__detail-label">REAL Pro tip</p>
            <p>${escapeHTML(spot.proTip)}</p>
            ${spot.proName ? `<cite>— ${escapeHTML(spot.proName)}, REAL Pro</cite>` : ''}
          </blockquote>
        ` : '';
        const conditionsMarkup = state.detailExpanded ? `
          <div class="session-map__conditions" aria-label="Conditions by sport">
            <p class="session-map__detail-label">Best by sport</p>
            ${renderSportConditions(spot)}
          </div>
        ` : '';

        detailEl.innerHTML = `
          <div class="session-map__detail-topbar">
            ${state.detailExpanded ? '' : kickerMarkup}
            <div class="session-map__detail-controls">
              ${state.detailExpanded ? `
                <button
                  class="session-map__detail-button"
                  type="button"
                  data-session-map-toggle-detail
                  aria-expanded="true"
                  aria-label="Hide spot info"
                  title="Hide spot info"
                >
                  <span class="session-map__detail-control-icon session-map__detail-control-icon--toggle" aria-hidden="true"></span>
                </button>
              ` : ''}
              <button class="session-map__detail-button session-map__detail-close" type="button" data-session-map-close-detail aria-label="Close selected spot" title="Close">
                <span class="session-map__detail-control-icon session-map__detail-control-icon--close" aria-hidden="true"></span>
              </button>
            </div>
          </div>
          ${imageMarkup}
          <div class="session-map__detail-main">
            ${state.detailExpanded ? kickerMarkup : ''}
            <h3>${escapeHTML(spot.name)}</h3>
            <p class="session-map__detail-summary">${escapeHTML(spot.summary)}</p>
          </div>
          <div class="session-map__detail-meta">
            <div class="session-map__sport-badges" aria-label="Sports">${renderSportBadges(spot.sports)}</div>
            <div class="session-map__tags" aria-label="Spot details">
              <span class="session-map__tag">Wind: ${escapeHTML(windText)}</span>
              <span class="session-map__tag">${escapeHTML(levelText)}</span>
            </div>
          </div>
          ${conditionsMarkup}
          ${proTipMarkup}
          ${state.detailExpanded ? renderReferenceLinks(spot.referenceLinks) : ''}
          <div class="session-map__detail-actions">
            <button
              class="session-map__detail-action session-map__detail-action--toggle"
              type="button"
              data-session-map-toggle-detail
              aria-expanded="${state.detailExpanded ? 'true' : 'false'}"
            >
              <span class="session-map__detail-action-label">${state.detailExpanded ? 'Hide spot info' : 'Show spot info'}</span>
              ${state.detailExpanded
                ? '<span class="session-map__detail-action-icon session-map__detail-action-icon--minus" aria-hidden="true">−</span>'
                : `<svg class="session-map__detail-action-icon" aria-hidden="true" focusable="false" viewBox="0 0 16 16">
                    <path fill="currentColor" fill-rule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707" />
                  </svg>`}
            </button>
            <a class="session-map__detail-action session-map__detail-action--map" href="${escapeHTML(mapHref)}" target="_blank" rel="noopener">Google Maps${externalLinkIcon}<span class="session-map__sr"> (opens in a new tab)</span></a>
          </div>
        `;
      };

      const focusMapOnSpot = (spot) => {
        if (!spot || !map || !window.ol?.proj || state.detailExpanded) return;

        const size = map.getSize();
        if (!size || !size[0] || !size[1]) return;

        const view = map.getView();
        const coordinate = window.ol.proj.fromLonLat([spot.lon, spot.lat]);
        const compactLayout = window.matchMedia('(max-width: 900px)').matches;
        const targetPixel = mobileQuery.matches
          ? [size[0] * 0.5, size[1] * 0.5]
          : compactLayout
          ? [size[0] * 0.5, size[1] * 0.24]
          : [size[0] * 0.7, size[1] * 0.36];
        const currentCenter = view.getCenter();

        view.centerOn(coordinate, size, targetPixel);
        const destinationCenter = view.getCenter();

        if (currentCenter && destinationCenter) {
          view.setCenter(currentCenter);
          view.animate({ center: destinationCenter, duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 280 });
        }
      };

      const setActiveSpot = (spotId, options = {}) => {
        const spotChanged = state.activeId !== spotId;
        state.activeId = spotId;
        if (!options.preserveDetailState) {
          state.detailHidden = false;
        }
        if (spotChanged) {
          state.detailExpanded = false;
        }
        const activeSpot = spots.find((spot) => spot.id === spotId);

        pinButtons.forEach((button, id) => {
          button.classList.toggle('is-active', id === spotId);
          button.setAttribute('aria-pressed', id === spotId ? 'true' : 'false');
        });

        root.querySelectorAll('[data-session-map-spot]').forEach((button) => {
          const active = button.dataset.sessionMapSpot === spotId;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
          if (active && options.panTo && !mobileQuery.matches) {
            button.scrollIntoView({ block: 'nearest' });
          }
        });

        renderDetail(activeSpot);

        if (activeSpot && options.panTo) {
          if (mobileQuery.matches) {
            window.requestAnimationFrame(() => {
              if (lifecycle.signal.aborted) return;
              map?.updateSize();
              focusMapOnSpot(activeSpot);
            });
          } else {
            focusMapOnSpot(activeSpot);
          }
        }
      };

      const renderList = (filteredSpots) => {
        listEl.innerHTML = '';

        if (!filteredSpots.length) {
          listEl.innerHTML = '<p class="session-map__empty">No spots match those filters yet. Try all wind directions or reset the filters.</p>';
          return;
        }

        filteredSpots.forEach((spot) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'session-map__spot-button';
          button.dataset.sessionMapSpot = spot.id;
          button.setAttribute('aria-label', `${spot.name}, ${spot.region}. ${toTitleList(spot.sports, sportLabels)}.`);
          button.setAttribute('aria-pressed', 'false');
          button.innerHTML = `
            ${renderSportStrip(spot.sports)}
            <span class="session-map__spot-name">${escapeHTML(spot.name)}</span>
            <span class="session-map__spot-meta">${escapeHTML(spot.region)}</span>
            <span class="session-map__spot-sports-text">${escapeHTML(toTitleList(spot.sports, sportLabels))}</span>
          `;
          listEl.append(button);
        });
      };

      const render = () => {
        const filteredSpots = getFilteredSpots();
        const visibleIds = new Set(filteredSpots.map((spot) => spot.id));
        const previousActiveId = state.activeId;

        if (!visibleIds.has(state.activeId)) {
          state.activeId = filteredSpots[0] ? filteredSpots[0].id : null;
          state.detailHidden = false;
          state.detailExpanded = false;
        }

        pinButtons.forEach((button, id) => {
          const isVisible = visibleIds.has(id);
          const spot = spots.find((item) => item.id === id);
          button.classList.toggle('is-muted', !isVisible);
          button.tabIndex = isVisible ? 0 : -1;
          button.dataset.visibleSport = state.sport === 'all' ? spot.primarySport : state.sport;
        });

        countEl.textContent = `${filteredSpots.length} ${filteredSpots.length === 1 ? 'spot' : 'spots'}`;
        root.querySelector('[data-session-map-mobile-count]').textContent = `(${filteredSpots.length})`;
        syncFilters();
        renderList(filteredSpots);
        setActiveSpot(state.activeId, {
          preserveDetailState: true,
          panTo: mobileQuery.matches && previousActiveId !== state.activeId
        });
      };

      const initOpenLayersMap = () => {
        loadOpenLayers()
          .then((ol) => {
            if (!root.isConnected || lifecycle.signal.aborted || mapEl.dataset.sessionMapOlReady === 'true') return;
            mapEl.dataset.sessionMapOlReady = 'true';
            const isCompactMap = window.matchMedia('(max-width: 900px)').matches;
            const desktopStartCenter = [-75.84, 35.35];

            map = new ol.Map({
              target: mapEl,
              layers: [
                new ol.layer.Tile({
                  source: new ol.source.OSM()
                })
              ],
              view: new ol.View({
                center: ol.proj.fromLonLat(desktopStartCenter),
                zoom: 10,
                minZoom: 8,
                maxZoom: 15
              })
            });

            const revealMap = () => root.classList.add('session-map--has-ol');
            map.once('rendercomplete', revealMap);
            revealMapTimer = window.setTimeout(revealMap, 4000);

            if (ol.extent && ol.extent.boundingExtent) {
              const extent = ol.extent.boundingExtent(spots.map((spot) => ol.proj.fromLonLat([spot.lon, spot.lat])));
              const view = map.getView();
              view.fit(extent, {
                padding: isCompactMap
                  ? [44, 42, 178, 42]
                  : [56, 72, 178, 72],
                maxZoom: 10.2
              });
              view.setZoom(Math.min(view.getZoom() + 1, 11.2));

              if (!isCompactMap) {
                view.setCenter(ol.proj.fromLonLat(desktopStartCenter));
              }
            }

            spots.forEach((spot) => {
              const marker = document.createElement('button');
              marker.type = 'button';
              marker.className = `session-map__pin session-map__pin--${spot.primarySport}${spot.id === 'real-watersports' ? ' session-map__pin--real' : ''}`;
              marker.dataset.spotId = spot.id;
              marker.setAttribute('aria-label', `${spot.name}, ${spot.region}`);
              marker.setAttribute('aria-pressed', 'false');
              marker.innerHTML = `<span class="session-map__sr">${escapeHTML(spot.name)}</span>`;

              map.addOverlay(new ol.Overlay({
                element: marker,
                position: ol.proj.fromLonLat([spot.lon, spot.lat]),
                positioning: 'center-center',
                stopEvent: false
              }));

              pinButtons.set(spot.id, marker);
            });

            activeLabelEl = document.createElement('div');
            activeLabelEl.className = 'session-map__active-label is-hidden';
            activeLabelEl.setAttribute('aria-hidden', 'true');

            const activeLabelDotEl = document.createElement('span');
            activeLabelDotEl.className = 'session-map__active-label-dot';

            activeLabelTextEl = document.createElement('span');
            activeLabelTextEl.className = 'session-map__active-label-name';

            activeLabelEl.append(activeLabelDotEl, activeLabelTextEl);
            activeLabelOverlay = new ol.Overlay({
              className: 'session-map__active-label-overlay',
              element: activeLabelEl,
              insertFirst: false,
              offset: [-32, 0],
              positioning: 'center-right',
              stopEvent: false
            });
            map.addOverlay(activeLabelOverlay);

            render();
            window.requestAnimationFrame(() => {
              if (!root.isConnected || lifecycle.signal.aborted) return;
              map.updateSize();
              if (mobileQuery.matches) focusMapOnSpot(spots.find((spot) => spot.id === state.activeId));
            });

            if ('ResizeObserver' in window) {
              mapResizeObserver = new ResizeObserver(() => {
                map.updateSize();
                if (mobileQuery.matches) focusMapOnSpot(spots.find((spot) => spot.id === state.activeId));
              });
              mapResizeObserver.observe(mapEl);
            }
          })
          .catch(() => {
            root.classList.add('session-map--map-failed');
          });
      };

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-session-map-guidance-toggle]')) {
          guidanceContent.hidden = !guidanceContent.hidden;
          guidanceToggle.setAttribute('aria-expanded', String(!guidanceContent.hidden));
          return;
        }
        if (event.target.closest('[data-session-map-filters-toggle]')) {
          setFiltersOpen(filtersEl.hidden);
          return;
        }
        if (event.target.closest('[data-session-map-filters-done]')) {
          setFiltersOpen(false, true);
          return;
        }
        if (event.target.closest('[data-session-map-explore]')) {
          openList();
          return;
        }
        if (event.target.closest('[data-session-map-sheet-close]')) {
          closeList();
          return;
        }
        const closeDetailButton = event.target.closest('[data-session-map-close-detail]');
        if (closeDetailButton) {
          state.detailHidden = true;
          state.detailExpanded = false;
          renderDetail(spots.find((spot) => spot.id === state.activeId));
          if (mobileQuery.matches) exploreEl.focus({ preventScroll: true });
          return;
        }

        const toggleDetailButton = event.target.closest('[data-session-map-toggle-detail]');
        if (toggleDetailButton) {
          state.detailExpanded = !state.detailExpanded;
          renderDetail(spots.find((spot) => spot.id === state.activeId));
          detailEl.scrollTop = 0;
          window.requestAnimationFrame(() => {
            if (lifecycle.signal.aborted) return;
            detailEl.querySelector('[data-session-map-toggle-detail]')?.focus();
          });
          return;
        }

        const filterButton = event.target.closest('[data-session-map-filter]');
        if (filterButton) {
          const filter = filterButton.dataset.sessionMapFilter;
          state[filter] = filterButton.dataset.value;
          render();
          return;
        }

        const pinButton = event.target.closest('[data-spot-id]');
        if (pinButton && !pinButton.classList.contains('is-muted')) {
          setActiveSpot(pinButton.dataset.spotId, { panTo: true });
          return;
        }

        const spotButton = event.target.closest('[data-session-map-spot]');
        if (spotButton) {
          setActiveSpot(spotButton.dataset.sessionMapSpot, { panTo: true });
          if (mobileQuery.matches) closeList(detailEl);
        }
      });

      root.addEventListener('change', (event) => {
        const select = event.target.closest('[data-session-map-select]');
        if (!select) return;
        state[select.dataset.sessionMapSelect] = select.value;
        render();
      });

      toolbarEl.addEventListener('focusout', (event) => {
        if (mobileQuery.matches && !toolbarEl.contains(event.relatedTarget)) setFiltersOpen(false);
      });

      if (searchEl) {
        searchEl.addEventListener('input', () => {
          state.query = searchEl.value;
          render();
        });
      }

      if (clearEl) {
        clearEl.addEventListener('click', () => {
          state.sport = 'all';
          state.wind = 'all';
          state.level = 'all';
          state.query = '';
          if (searchEl) searchEl.value = '';
          render();
        });
      }

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && sheetEl.open) return;
        if (event.key === 'Escape' && mobileQuery.matches && !filtersEl.hidden) {
          event.preventDefault();
          setFiltersOpen(false, true);
          return;
        }
        if (event.key === 'Escape' && mobileQuery.matches && !guidanceContent.hidden && guidanceContent.contains(event.target)) {
          event.preventDefault();
          guidanceContent.hidden = true;
          guidanceToggle.setAttribute('aria-expanded', 'false');
          guidanceToggle.focus({ preventScroll: true });
          return;
        }
        if (event.key !== 'Escape' || state.detailHidden) return;

        event.preventDefault();
        if (state.detailExpanded) {
          state.detailExpanded = false;
          renderDetail(spots.find((spot) => spot.id === state.activeId));
          detailEl.querySelector('[data-session-map-toggle-detail]')?.focus();
          return;
        }

        state.detailHidden = true;
        renderDetail(spots.find((spot) => spot.id === state.activeId));
        if (mobileQuery.matches) exploreEl.focus({ preventScroll: true });
        else root.querySelector(`[data-session-map-spot="${state.activeId}"]`)?.focus();
      });

      syncMobileLayout();
      initOpenLayersMap();
      render();
    };

    const initAllSessionMaps = (scope = document) => {
      scope.querySelectorAll(rootSelector).forEach(initSessionMap);
    };

    initAllSessionMaps();
    document.addEventListener('shopify:section:load', (event) => initAllSessionMaps(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(rootSelector).forEach((root) => {
        cleanups.get(root)?.();
        cleanups.delete(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-navigation-menus"] && !Shopify.designMode) return;
  try {
    
  class CollectionNavigationMenus extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details.has-active-subcollection');

      if (!this.details) return;

      this.details.setAttribute('data-desktop-disclosure-enhanced', '');
      this.summary = this.details.querySelector('summary');
      this.closeButton = this.details.querySelector('[data-collection-navigation-close]');
      this.mobileQuery = window.matchMedia('(max-width: 989px)');
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.collapseOnMobile = this.details.dataset.collapseOnMobile === 'true';
      this.handleMediaChange = () => {
        const nextOpen = this.mobileQuery.matches && !this.collapseOnMobile;
        const focusIsInside = this.details.contains(document.activeElement);

        this.clearDisclosureTransition();

        if (this.details.open !== nextOpen) {
          this.details.open = nextOpen;

          if (!nextOpen && focusIsInside && document.activeElement !== this.summary) {
            this.summary?.focus({ preventScroll: true });
          }
        }
      };
      this.handleSummaryClick = (event) => {
        if (this.mobileQuery.matches) return;

        event.preventDefault();
        this.setDetailsOpen(!this.details.open);
      };
      this.handleCloseClick = () => {
        this.setDetailsOpen(false);
      };
      this.handleKeydown = (event) => {
        if (event.key !== 'Escape' || this.mobileQuery.matches || !this.details.open) return;

        event.preventDefault();
        this.setDetailsOpen(false);
      };

      this.handleMediaChange();
      this.mobileQuery.addEventListener('change', this.handleMediaChange);
      this.summary?.addEventListener('click', this.handleSummaryClick);
      this.closeButton?.addEventListener('click', this.handleCloseClick);
      this.details.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      this.mobileQuery?.removeEventListener('change', this.handleMediaChange);
      this.summary?.removeEventListener('click', this.handleSummaryClick);
      this.closeButton?.removeEventListener('click', this.handleCloseClick);
      this.details?.removeEventListener('keydown', this.handleKeydown);
      this.details?.removeAttribute('data-desktop-disclosure-enhanced');
      this.clearDisclosureTransition();
    }

    clearDisclosureTransition() {
      window.clearTimeout(this.animationCleanup);
      this.details?.removeAttribute('data-disclosure-transition');
    }

    setDetailsOpen(nextOpen) {
      if (this.details.open === nextOpen) return;

      this.clearDisclosureTransition();

      if (!this.reducedMotionQuery.matches) {
        const transitionState = nextOpen ? 'opening' : 'closing';

        this.details.dataset.disclosureTransition = transitionState;
        this.animationCleanup = window.setTimeout(() => {
          if (this.details.dataset.disclosureTransition === transitionState) {
            this.details.removeAttribute('data-disclosure-transition');
          }
        }, 400);
      }

      this.details.open = nextOpen;

      if (nextOpen) {
        this.closeButton?.focus({ preventScroll: true });
      } else {
        this.summary?.focus({ preventScroll: true });
      }
    }
  }

  if (!customElements.get('collection-navigation-menus')) {
    customElements.define('collection-navigation-menus', CollectionNavigationMenus);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-surfboard-model"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["package-builder-real"] && !Shopify.designMode) return;
  try {
    
  class RealPackageBuilder extends HTMLElement {
    // Share an unresolved receipt across theme-editor section replacement.
    static cartAttempts = new Map();

    connectedCallback() {
      if (this.dataset.initialized === 'true') {
        if (this.handleBlockSelect) {
          document.addEventListener('shopify:block:select', this.handleBlockSelect);
        }
        this.bindFloatingLayout();
        return;
      }
      this.dataset.initialized = 'true';

      this.steps = Array.from(this.querySelectorAll('[data-package-step]'));
      this.reviewPanel = this.querySelector('[data-package-review]');
      this.currentIndex = 0;
      this.maxVisited = 0;
      this.storageKey = `real-package-builder:${this.dataset.builderKey || this.id}`;
      this.moneyFormatter = null;

      this.initializeOptions();
      this.buildProgress();
      this.restoreState();
      this.restoreCartAttempt();
      this.bindEvents();
      this.showPanel(this.currentIndex, { focus: false, persist: false });
      this.updateAll();
      this.bindFloatingLayout();
      this.loadMoneyFormatter();
    }

    disconnectedCallback() {
      if (this.handleBlockSelect) {
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }
      this.unbindFloatingLayout();
    }

    bindFloatingLayout() {
      this.mobileBar = this.querySelector('[data-package-mobile-bar]');
      this.handleViewportResize ||= () => this.syncFloatingChatOffset();
      window.addEventListener('resize', this.handleViewportResize);

      if (!this.mobileBarResizeObserver && typeof ResizeObserver !== 'undefined') {
        this.mobileBarResizeObserver = new ResizeObserver(() => this.syncFloatingChatOffset());
      }
      if (this.mobileBar) this.mobileBarResizeObserver?.observe(this.mobileBar);
      this.syncFloatingChatOffset();
    }

    unbindFloatingLayout() {
      if (this.handleViewportResize) window.removeEventListener('resize', this.handleViewportResize);
      this.mobileBarResizeObserver?.disconnect();
      const root = document.documentElement;
      root.removeAttribute('data-package-builder-mobile-bar-visible');
      root.style.removeProperty('--package-builder-chat-offset');
    }

    syncFloatingChatOffset() {
      const root = document.documentElement;
      const mobileBarHeight = Math.ceil(this.mobileBar?.getBoundingClientRect().height || 0);
      const mobileBarVisible = window.matchMedia('(max-width: 989px)').matches && mobileBarHeight > 0;

      if (!mobileBarVisible) {
        root.removeAttribute('data-package-builder-mobile-bar-visible');
        root.style.removeProperty('--package-builder-chat-offset');
        return;
      }

      root.setAttribute('data-package-builder-mobile-bar-visible', '');
      root.style.setProperty('--package-builder-chat-offset', `${mobileBarHeight + 16}px`);
    }

    async loadMoneyFormatter() {
      try {
        const module = await import('@theme/money-formatting');
        this.moneyFormatter = module.formatMoney;
        this.updateAll();
      } catch (error) {
        console.warn('Package builder money formatting fallback in use.', error);
      }
    }

    initializeOptions() {
      this.steps.forEach((step, stepIndex) => {
        const singleSelection = step.dataset.selectionMode === 'required_single';
        const inputs = this.inputsForStep(step);

        inputs.forEach((input) => {
          input.type = singleSelection ? 'radio' : 'checkbox';
          input.name = singleSelection
            ? `${this.id}-step-${stepIndex}`
            : `${this.id}-step-${stepIndex}-${input.closest('[data-package-option]')?.dataset.productId}`;
          this.syncVariant(input.closest('[data-package-option]'));
          this.syncCard(input);
        });

        const count = step.querySelector('[data-package-step-count]');
        if (count) {
          count.textContent = `${this.dataset.stepLabel} ${stepIndex + 1} ${this.dataset.ofLabel} ${this.steps.length}`;
        }

        const back = step.querySelector('[data-package-back]');
        if (back) back.disabled = stepIndex === 0;

        const next = step.querySelector('[data-package-next]');
        if (next && stepIndex === this.steps.length - 1) next.textContent = this.dataset.reviewLabel;
      });
    }

    buildProgress() {
      const list = this.querySelector('[data-package-progress]');
      if (!list) return;
      list.replaceChildren();

      [...this.steps, this.reviewPanel].forEach((panel, index) => {
        if (!panel) return;
        const item = document.createElement('li');
        const button = document.createElement('button');
        const number = document.createElement('span');
        const label = document.createElement('span');

        button.type = 'button';
        button.dataset.packageProgressButton = String(index);
        number.className = 'package-builder__progress-index';
        number.textContent = index === this.steps.length ? '✓' : String(index + 1);
        label.className = 'package-builder__progress-label';
        label.textContent = index === this.steps.length ? this.dataset.reviewLabel : panel.dataset.stepTitle;
        button.append(number, label);
        item.append(button);
        list.append(item);
      });
    }

    bindEvents() {
      this.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;

        if (target.matches('[data-package-option-input]')) {
          const step = target.closest('[data-package-step]');
          const error = step?.querySelector('[data-package-step-error]');
          if (error) error.hidden = true;
          if (!target.checked) this.clearVariantError(target.closest('[data-package-option]'));
          this.announce('');
          this.inputsForStep(step).forEach((input) => this.syncCard(input));
          this.persistState();
          this.updateAll();
        }

        if (target.matches('[data-package-variant]')) {
          const card = target.closest('[data-package-option]');
          const input = card?.querySelector('[data-package-option-input]');
          const variant = target.selectedOptions?.[0];
          if (target.disabled || !input || input.disabled || !variant?.value || variant.disabled) return;

          const step = target.closest('[data-package-step]');
          this.syncVariant(card);
          input.checked = true;
          this.inputsForStep(step).forEach((stepInput) => this.syncCard(stepInput));
          this.clearVariantError(card);
          const error = step?.querySelector('[data-package-step-error]');
          if (error) error.hidden = true;
          this.announce('');
          this.persistState();
          this.updateAll();
        }
      });

      this.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const next = target.closest('[data-package-next]');
        if (next) {
          const step = next.closest('[data-package-step]');
          const index = this.steps.indexOf(step);
          if (this.validateStep(index)) this.showPanel(index + 1);
          return;
        }

        if (target.closest('[data-package-back]')) {
          const step = target.closest('[data-package-step]');
          this.showPanel(Math.max(0, this.steps.indexOf(step) - 1));
          return;
        }

        if (target.closest('[data-package-review-back]')) {
          this.showPanel(this.steps.length - 1);
          return;
        }

        const progress = target.closest('[data-package-progress-button]');
        if (progress) {
          const index = Number(progress.dataset.packageProgressButton);
          if (index <= this.maxVisited) this.showPanel(index);
          return;
        }

        const edit = target.closest('[data-package-edit-step]');
        if (edit) {
          this.showPanel(Number(edit.dataset.packageEditStep));
          return;
        }

        if (target.closest('[data-package-add]')) {
          this.addPackageToCart();
          return;
        }

        if (target.closest('[data-package-reset]')) {
          this.resetBuild();
          return;
        }

        if (target.closest('[data-package-summary-open]')) {
          this.querySelector('[data-package-dialog]')?.showModal();
          return;
        }

        if (target.closest('[data-package-summary-close], [data-package-dialog-continue]')) {
          this.querySelector('[data-package-dialog]')?.close();
        }
      });

      this.handleBlockSelect = (event) => {
        const block = event.target;
        if (!(block instanceof Element) || !this.contains(block)) return;
        const step = block.closest('[data-package-step]');
        const index = this.steps.indexOf(step);
        if (index >= 0) this.showPanel(index, { focus: false, persist: false, unlock: true });
      };
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    inputsForStep(step) {
      if (!step) return [];
      return Array.from(step.querySelectorAll('[data-package-option-input]'));
    }

    ensureOnlyAvailableOption(step) {
      if (!step || step.dataset.selectionMode !== 'required_single') return;
      const availableInputs = this.inputsForStep(step).filter((input) => !input.disabled);
      if (availableInputs.length === 1 && !availableInputs[0].checked) {
        availableInputs[0].checked = true;
        this.syncCard(availableInputs[0]);
      }
    }

    syncVariant(card) {
      if (!card) return;
      const input = card.querySelector('[data-package-option-input]');
      const select = card.querySelector('[data-package-variant]');
      const staticData = card.querySelector('[data-package-variant-data]');
      const variant = select?.selectedOptions?.[0] || staticData;
      if (!input || !variant) return;

      const placeholder = variant.hasAttribute('data-package-variant-placeholder');
      input.value = placeholder ? card.dataset.unselectedValue : variant.value || variant.dataset.variantId;
      card.dataset.variantId = placeholder ? '' : input.value;
      card.dataset.price = variant.dataset.price || '0';
      card.dataset.priceDisplay = variant.dataset.priceDisplay || this.formatMoney(Number(card.dataset.price));
      card.dataset.compareDisplay = variant.dataset.compareDisplay || '';
      card.dataset.variantTitle = placeholder
        ? ''
        : select?.selectedOptions?.[0]?.dataset.variantTitle ||
          select?.selectedOptions?.[0]?.textContent?.split(' — ')[0]?.trim() ||
          '';

      const price = card.querySelector('[data-package-option-price]');
      const compare = card.querySelector('[data-package-option-compare]');
      if (price) price.textContent = card.dataset.priceDisplay;
      if (compare) {
        compare.textContent = card.dataset.compareDisplay;
        compare.classList.toggle('is-hidden', !card.dataset.compareDisplay);
      }
    }

    clearVariantError(card) {
      if (!card) return;
      card.querySelector('[data-package-variant]')?.removeAttribute('aria-invalid');
      const error = card.querySelector('[data-package-variant-error]');
      if (error) error.hidden = true;
    }

    showVariantError(card) {
      if (!card) return;
      const select = card.querySelector('[data-package-variant]');
      const error = card.querySelector('[data-package-variant-error]');
      select?.setAttribute('aria-invalid', 'true');
      if (error) error.hidden = false;
      this.announce(error?.textContent?.trim() || '');
      select?.focus();
    }

    unresolvedVariantForStep(step) {
      return this.inputsForStep(step).find((input) => {
        if (!input.checked || input.disabled) return false;
        const card = input.closest('[data-package-option]');
        return card?.dataset.variantChoiceRequired === 'true' && !card.dataset.variantId;
      });
    }

    syncCard(input) {
      input?.closest('[data-package-option]')?.classList.toggle('is-selected', Boolean(input.checked));
    }

    validateStep(index) {
      const step = this.steps[index];
      if (!step) return true;
      const inputs = this.inputsForStep(step);
      const selectionMode = step.dataset.selectionMode;
      const required = selectionMode === 'required_single' || selectionMode === 'required_multiple';
      const selected =
        selectionMode === 'required_multiple'
          ? inputs.length > 0 && inputs.every((input) => input.checked && !input.disabled)
          : inputs.some((input) => input.checked && !input.disabled);
      const error = step.querySelector('[data-package-step-error]');

      if (required && !selected) {
        if (error) error.hidden = false;
        this.announce(error?.textContent?.trim() || '');
        inputs.find((input) => !input.checked || input.disabled)?.focus();
        return false;
      }

      if (error) error.hidden = true;
      const unresolvedVariant = this.unresolvedVariantForStep(step);
      if (unresolvedVariant) {
        this.showVariantError(unresolvedVariant.closest('[data-package-option]'));
        return false;
      }
      return true;
    }

    validateAll() {
      for (let index = 0; index < this.steps.length; index += 1) {
        if (!this.validateStep(index)) {
          this.showPanel(index, { focus: false });
          return false;
        }
      }
      return true;
    }

    showPanel(index, options = {}) {
      const { focus = true, persist = true, unlock = false } = options;
      if (this.isCartAttemptLocked()) index = this.steps.length;
      const boundedIndex = Math.max(0, Math.min(index, this.steps.length));
      this.currentIndex = boundedIndex;
      this.maxVisited = Math.max(this.maxVisited, unlock ? boundedIndex : Math.min(boundedIndex, this.maxVisited + 1));

      this.steps.forEach((step, stepIndex) => {
        step.hidden = stepIndex !== boundedIndex;
      });
      if (this.reviewPanel) this.reviewPanel.hidden = boundedIndex !== this.steps.length;
      this.ensureOnlyAvailableOption(this.steps[boundedIndex]);

      if (boundedIndex === this.steps.length) this.renderReview();
      this.updateAll();
      if (persist) this.persistState();

      if (focus) {
        const panel = boundedIndex === this.steps.length ? this.reviewPanel : this.steps[boundedIndex];
        panel?.querySelector('h2')?.focus({ preventScroll: true });
        requestAnimationFrame(() => this.scrollPanelIntoView(panel));
      }
    }

    scrollPanelIntoView(panel) {
      const header = panel?.querySelector('.package-builder__step-header');
      if (!header) return;

      const headerRect = header.getBoundingClientRect();
      const progressRect = this.querySelector('.package-builder__progress')?.getBoundingClientRect();
      const visibleTop = Math.max(0, progressRect?.bottom || 0) + 12;
      const visibleBottom = document.documentElement.clientHeight;

      if (headerRect.top >= visibleTop && headerRect.bottom <= visibleBottom) return;

      header.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start',
      });
    }

    updateProgress() {
      this.querySelectorAll('[data-package-progress-button]').forEach((button) => {
        const index = Number(button.dataset.packageProgressButton);
        const active = index === this.currentIndex;
        const complete =
          index < this.currentIndex ||
          (index <= this.maxVisited && index < this.steps.length && this.stepHasSelection(index));
        button.toggleAttribute('aria-current', active);
        if (active) button.setAttribute('aria-current', 'step');
        button.dataset.complete = String(complete);
        button.disabled = index > this.maxVisited;
      });
    }

    stepHasSelection(index) {
      const step = this.steps[index];
      const inputs = this.inputsForStep(step);
      if (this.unresolvedVariantForStep(step)) return false;
      if (step?.dataset.selectionMode === 'required_multiple') {
        return inputs.length > 0 && inputs.every((input) => input.checked && !input.disabled);
      }
      return inputs.some((input) => input.checked && !input.disabled);
    }

    selectedItems() {
      const items = [];
      this.steps.forEach((step, stepIndex) => {
        if (stepIndex > this.maxVisited) return;
        this.inputsForStep(step)
          .filter((input) => input.checked && !input.disabled)
          .forEach((input) => {
            const card = input.closest('[data-package-option]');
            if (!card?.dataset.variantId) return;
            items.push({
              stepIndex,
              stepKey: step.dataset.stepKey,
              stepTitle: step.dataset.stepTitle,
              productId: card.dataset.productId,
              productTitle: card.dataset.productTitle,
              variantId: card.dataset.variantId,
              variantTitle: card.dataset.variantTitle,
              price: Number(card.dataset.price || 0),
              priceDisplay: card.dataset.priceDisplay || '',
            });
          });
      });
      return items;
    }

    updateAll() {
      const items = this.selectedItems();
      const total = items.reduce((sum, item) => sum + item.price, 0);
      this.renderCompactSummary(this.querySelector('[data-package-summary-list]'), items);
      this.renderCompactSummary(this.querySelector('[data-package-dialog-list]'), items);

      this.querySelectorAll('[data-package-summary-total], [data-package-dialog-total], [data-package-mobile-total]').forEach(
        (element) => {
          element.textContent = this.formatMoney(total);
        }
      );

      const count = this.querySelector('[data-package-summary-count]');
      if (count) count.textContent = String(items.length);
      const mobileCount = this.querySelector('[data-package-mobile-count]');
      if (mobileCount) {
        mobileCount.textContent =
          items.length === 0 ? this.dataset.emptyLabel : `${items.length} ${this.dataset.selectedLabel}`;
      }
      this.querySelectorAll('[data-package-reset]').forEach((button) => {
        button.hidden = items.length === 0;
      });

      this.updateProgress();
      if (this.currentIndex === this.steps.length) this.renderReview();
      this.renderCartAttempt();
    }

    renderCompactSummary(container, items) {
      if (!container) return;
      container.replaceChildren();
      if (items.length === 0) {
        const empty = document.createElement('p');
        empty.className = 'package-builder__summary-empty';
        empty.textContent = this.dataset.emptyLabel;
        container.append(empty);
        return;
      }

      items.forEach((item) => {
        const row = document.createElement('div');
        const step = document.createElement('small');
        const title = document.createElement('strong');
        const price = document.createElement('span');
        row.className = 'package-builder__summary-item';
        step.textContent = item.stepTitle;
        title.textContent = this.itemTitle(item);
        price.className = 'package-builder__summary-item-price';
        price.textContent = item.priceDisplay;
        row.append(step, title, price);
        container.append(row);
      });
    }

    renderReview() {
      const container = this.querySelector('[data-package-review-list]');
      const totalElement = this.querySelector('[data-package-review-total]');
      if (!container || !totalElement) return;
      const items = this.selectedItems();
      const total = items.reduce((sum, item) => sum + item.price, 0);
      container.replaceChildren();

      items.forEach((item) => {
        const row = document.createElement('div');
        const step = document.createElement('small');
        const title = document.createElement('strong');
        const price = document.createElement('span');
        const edit = document.createElement('button');
        row.className = 'package-builder__review-item';
        step.textContent = item.stepTitle;
        title.textContent = this.itemTitle(item);
        price.className = 'package-builder__review-item-price';
        price.textContent = item.priceDisplay;
        edit.type = 'button';
        edit.className = 'package-builder__review-edit';
        edit.dataset.packageEditStep = String(item.stepIndex);
        edit.textContent = this.dataset.editLabel;
        edit.setAttribute('aria-label', `${this.dataset.editLabel} ${item.stepTitle}`);
        row.append(step, title, price, edit);
        container.append(row);
      });

      totalElement.textContent = this.formatMoney(total);
    }

    itemTitle(item) {
      if (!item.variantTitle || item.variantTitle === this.dataset.defaultVariantLabel) return item.productTitle;
      return `${item.productTitle} — ${item.variantTitle}`;
    }

    formatMoney(value) {
      if (this.moneyFormatter) {
        return this.moneyFormatter(value, this.dataset.moneyFormat, this.dataset.currency);
      }
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.dataset.currency || 'USD',
        }).format(value / 100);
      } catch {
        return `${(value / 100).toFixed(2)} ${this.dataset.currency || ''}`.trim();
      }
    }

    persistState() {
      try {
        const selections = {};
        this.steps.forEach((step) => {
          selections[step.dataset.stepKey] = this.inputsForStep(step)
            .filter((input) => input.checked && !input.disabled)
            .map((input) => input.value);
        });
        localStorage.setItem(
          this.storageKey,
          JSON.stringify({ selections, currentIndex: this.currentIndex, maxVisited: this.maxVisited })
        );
      } catch {
        // Persistence is a convenience; private browsing restrictions should not block the builder.
      }
    }

    restoreState() {
      let saved;
      try {
        saved = JSON.parse(localStorage.getItem(this.storageKey) || 'null');
        if (saved === null) return;
        const validSelection = (value) => {
          if (typeof value === 'string' && /^unselected:[1-9]\d*$/.test(value)) return true;
          return (typeof value === 'number' || (typeof value === 'string' && /^[1-9]\d*$/.test(value))) &&
            Number.isSafeInteger(Number(value)) && Number(value) > 0;
        };
        if (
          typeof saved !== 'object' || Array.isArray(saved) ||
          !saved.selections || typeof saved.selections !== 'object' || Array.isArray(saved.selections) ||
          !Object.values(saved.selections).every((values) => Array.isArray(values) && values.every(validSelection))
        ) throw new Error('Invalid saved package progress');
      } catch {
        this.clearSavedProgress();
        return;
      }

      this.steps.forEach((step) => {
        const variantIds = saved.selections[step.dataset.stepKey];
        if (!Array.isArray(variantIds)) return;
        const inputs = this.inputsForStep(step);
        inputs.forEach((input) => {
          input.checked = false;
        });

        variantIds.forEach((variantId) => {
          const input =
            inputs.find((candidate) => candidate.value === String(variantId)) ||
            inputs.find((candidate) => {
              const select = candidate.closest('[data-package-option]')?.querySelector('[data-package-variant]');
              const option = Array.from(select?.options || []).find((item) => item.value === String(variantId));
              if (!option || option.disabled) return false;
              select.value = option.value;
              this.syncVariant(candidate.closest('[data-package-option]'));
              return true;
            });
          if (input && !input.disabled) input.checked = true;
        });
        inputs.forEach((input) => this.syncCard(input));
      });

      const boundedIndex = (value) => Number.isSafeInteger(value) && value >= 0 ? Math.min(value, this.steps.length) : 0;
      this.currentIndex = boundedIndex(saved.currentIndex);
      this.maxVisited = Math.max(this.currentIndex, boundedIndex(saved.maxVisited));
    }

    clearSavedProgress() {
      try {
        localStorage.removeItem(this.storageKey);
      } catch {
        // Saved progress is optional, including when its cleanup is blocked.
      }
    }

    resetBuild() {
      this.cartAttempt = RealPackageBuilder.cartAttempts.get(this.storageKey) || this.cartAttempt;
      if (this.isCartAttemptLocked()) return;
      this.cartAttempt = null;
      this.cartMessage = '';
      this.steps.forEach((step) => {
        this.inputsForStep(step).forEach((input) => {
          const card = input.closest('[data-package-option]');
          input.checked = card?.dataset.defaultSelected === 'true' && !input.disabled;
          const select = card?.querySelector('[data-package-variant]');
          if (select) {
            const placeholder = select.querySelector('[data-package-variant-placeholder]');
            const firstAvailable = Array.from(select.options).find((option) => !option.disabled);
            if (placeholder) select.value = placeholder.value;
            else if (firstAvailable) select.value = firstAvailable.value;
          }
          this.syncVariant(card);
          this.clearVariantError(card);
          this.syncCard(input);
        });
        const error = step.querySelector('[data-package-step-error]');
        if (error) error.hidden = true;
      });

      this.clearSavedProgress();
      this.currentIndex = 0;
      this.maxVisited = 0;
      const dialog = this.querySelector('[data-package-dialog]');
      if (dialog?.open) dialog.close();
      const status = this.querySelector('[data-package-cart-status]');
      if (status) status.textContent = '';
      const addButton = this.querySelector('[data-package-add]');
      if (addButton) {
        addButton.disabled = false;
        addButton.textContent = this.dataset.addLabel;
      }
      this.announce('');
      this.showPanel(0, { persist: false });
    }

    isCartAttemptLocked() {
      const attempt = this.cartAttempt;
      return Boolean(attempt && (attempt.inFlight || !['complete', 'rejected'].includes(attempt.outcome)));
    }

    restoreCartAttempt() {
      this.cartAttempt = RealPackageBuilder.cartAttempts.get(this.storageKey);
      if (!this.cartAttempt) {
        try {
          const receipt = JSON.parse(sessionStorage.getItem(`${this.storageKey}:cart-attempt`) || 'null');
          if (
            typeof receipt?.packageId === 'string' && receipt.packageId &&
            Array.isArray(receipt.items) && receipt.items.length > 0 && receipt.items.length <= 250 &&
            receipt.items.every((item) => Number.isSafeInteger(Number(item?.variantId)) && Number(item.variantId) > 0 &&
              typeof item.stepKey === 'string')
          ) {
            this.cartAttempt = {
              packageId: receipt.packageId,
              items: receipt.items.map(({ variantId, stepKey }) => ({ variantId: String(variantId), stepKey })),
              acknowledged: receipt.acknowledged === true,
              rejectionMessage: typeof receipt.rejectionMessage === 'string' ? receipt.rejectionMessage : '',
              submitted: true,
              outcome: 'unknown',
              inFlight: false,
            };
            RealPackageBuilder.cartAttempts.set(this.storageKey, this.cartAttempt);
          }
        } catch {
          // Storage is optional; the in-memory lock still protects this page.
        }
      }
      if (this.isCartAttemptLocked()) {
        this.currentIndex = this.steps.length;
        this.maxVisited = this.steps.length;
      }
    }

    saveCartAttempt() {
      const attempt = this.cartAttempt;
      const pending = attempt && !['complete', 'rejected'].includes(attempt.outcome);
      if (pending) RealPackageBuilder.cartAttempts.set(this.storageKey, attempt);
      else RealPackageBuilder.cartAttempts.delete(this.storageKey);
      try {
        if (pending && attempt.submitted) {
          sessionStorage.setItem(`${this.storageKey}:cart-attempt`, JSON.stringify({
            packageId: attempt.packageId,
            items: attempt.items,
            acknowledged: Boolean(attempt.acknowledged),
            rejectionMessage: attempt.rejectionMessage || '',
          }));
        } else {
          sessionStorage.removeItem(`${this.storageKey}:cart-attempt`);
        }
      } catch {
        // Never turn an accepted cart write into a failed Add because storage failed.
      }
    }

    renderCartAttempt() {
      const attempt = this.cartAttempt;
      const locked = this.isCartAttemptLocked();
      const busy = Boolean(attempt?.inFlight);
      this.querySelectorAll('[data-package-step], .package-builder__progress').forEach(
        (element) => { element.inert = locked; }
      );
      this.querySelectorAll('[data-package-reset], [data-package-review-back], [data-package-edit-step]').forEach(
        (button) => { button.disabled = locked; }
      );
      const button = this.querySelector('[data-package-add]');
      if (button) {
        button.disabled = busy || attempt?.outcome === 'complete';
        button.textContent = busy
          ? (attempt.phase === 'add' ? this.dataset.addingLabel : this.dataset.checkingCartLabel)
          : attempt?.outcome === 'complete' ? this.dataset.addedLabel
            : locked ? this.dataset.checkCartLabel : this.dataset.addLabel;
        button.setAttribute('aria-busy', String(busy));
      }
      const message = busy ? '' : attempt?.outcome === 'complete' ? this.dataset.addedLabel
        : attempt?.outcome === 'partial' ? this.dataset.cartPartialLabel
          : locked ? (attempt.acknowledged ? this.dataset.cartRefreshErrorLabel : this.dataset.cartUnconfirmedLabel)
            : this.cartMessage || attempt?.rejectionMessage || '';
      const status = this.querySelector('[data-package-cart-status]');
      if (status && status.textContent !== message) status.textContent = message;
      const recovery = this.querySelector('[data-package-cart-recovery]');
      if (recovery) recovery.hidden = !attempt?.submitted;
    }

    async withCartDeadline(operation) {
      const controller = new AbortController();
      let timer;
      try {
        return await Promise.race([
          Promise.resolve().then(() => operation(controller.signal)),
          new Promise((_, reject) => {
            timer = setTimeout(() => {
              controller.abort();
              reject(new Error('Package cart request timed out'));
            }, 10000);
          }),
        ]);
      } finally {
        clearTimeout(timer);
      }
    }

    async fetchPackageCartJSON(url, options = {}) {
      return this.withCartDeadline(async (signal) => {
        const response = await fetch(url, {
          ...options, signal, cache: 'no-store', credentials: 'same-origin',
          headers: { Accept: 'application/json', ...options.headers },
        });
        const data = await response.json();
        if (!data || typeof data !== 'object' || Array.isArray(data)) throw new Error('Invalid cart response');
        return { response, data };
      });
    }

    async readPackageCart() {
      const component = document.querySelector('cart-items-component');
      let cart;
      if (typeof component?.fetchCartData === 'function') {
        cart = await this.withCartDeadline(() => component.fetchCartData());
      } else {
        const result = await this.fetchPackageCartJSON(`${Theme.routes.cart_url}.json`);
        if (!result.response.ok) throw new Error('Cart refresh failed');
        cart = result.data;
      }
      if (!Array.isArray(cart?.items) || !Number.isFinite(cart.item_count) || !Number.isFinite(cart.total_price) ||
        typeof cart.currency !== 'string' || !cart.items.every((item) =>
          (typeof item?.variant_id === 'number' || typeof item?.variant_id === 'string') &&
          Number.isFinite(item.quantity) && item.quantity >= 0)) throw new Error('Invalid cart data');
      return cart;
    }

    packageReceiptState(lines, attempt) {
      if (!Array.isArray(lines)) return 'missing';
      const received = lines.filter((line) => line.properties?._package_id === attempt.packageId);
      if (received.length === 0) return 'missing';
      const counts = (items, key, quantity) => {
        const result = new Map();
        items.forEach((item) => result.set(key(item), (result.get(key(item)) || 0) + quantity(item)));
        return result;
      };
      const expected = counts(attempt.items, (item) => JSON.stringify([item.stepKey, String(item.variantId)]), () => 1);
      const actual = counts(received,
        (line) => JSON.stringify([line.properties._package_step, String(line.variant_id ?? line.id)]),
        (line) => Number(line.quantity));
      return actual.size === expected.size && [...expected].every(([key, quantity]) => actual.get(key) === quantity)
        ? 'complete' : 'partial';
    }

    async addPackageToCart() {
      this.cartAttempt = RealPackageBuilder.cartAttempts.get(this.storageKey) || this.cartAttempt;
      if (this.cartAttempt?.inFlight || this.cartAttempt?.outcome === 'complete') return;
      const recovering = this.isCartAttemptLocked();
      if (!recovering) {
        if (!this.validateAll()) return;
        const items = this.selectedItems().map(({ variantId, stepKey }) => ({ variantId: String(variantId), stepKey }));
        if (!items.length || !items.every((item) => Number.isSafeInteger(Number(item.variantId)) && Number(item.variantId) > 0)) return;
        this.cartAttempt = {
          packageId: globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`,
          items, submitted: false, outcome: 'unknown', inFlight: false,
        };
      }
      const attempt = this.cartAttempt;
      attempt.inFlight = true;
      attempt.phase = recovering ? 'check' : 'add';
      this.cartMessage = '';
      this.saveCartAttempt();
      this.renderCartAttempt();
      let events;
      let deferred;
      let cart;
      const handleCartActivity = (event) => {
        if (event.target !== this) attempt.overlapped = true;
      };
      document.addEventListener('shopify:cart:lines-update', handleCartActivity);

      try {
        if (!recovering) {
          events = await this.withCartDeadline(() => import('@shopify/events'));
          deferred = events.CartLinesUpdateEvent.createPromise();
          this.dispatchEvent(new events.CartLinesUpdateEvent({
            action: 'add', context: 'cart',
            lines: attempt.items.map((item) => ({ merchandiseId: item.variantId, quantity: 1 })),
            promise: deferred.promise,
          }));
          const body = JSON.stringify({ items: attempt.items.map((item) => ({
            id: Number(item.variantId), quantity: 1,
            properties: {
              Package: this.dataset.builderTitle, _package_builder_key: this.dataset.builderKey,
              _package_id: attempt.packageId, _package_step: item.stepKey,
            },
          })) });
          // Receipt properties identify the result; they do not make a second POST idempotent.
          attempt.submitted = true;
          this.saveCartAttempt();
          try {
            const { response, data } = await this.fetchPackageCartJSON(Theme.routes.cart_add_url, {
              method: 'POST', headers: { 'Content-Type': 'application/json' }, body,
            });
            const message = [data.description, data.message, data.errors].find((value) => typeof value === 'string' && value.trim());
            if ([400, 422].includes(response.status) && Number(data.status) === response.status && message) {
              attempt.rejectionMessage = message;
            } else if (response.ok && !data.status && this.packageReceiptState(data.items, attempt) === 'complete') {
              attempt.acknowledged = true;
            }
          } catch (error) {
            console.warn('[package-builder] Add outcome needs cart verification:', error);
          }
          this.saveCartAttempt();
        }

        attempt.phase = 'check';
        this.renderCartAttempt();
        cart = await this.readPackageCart();
        const receiptState = this.packageReceiptState(cart.items, attempt);
        if (receiptState === 'complete') {
          attempt.outcome = 'complete';
          this.clearSavedProgress();
        } else if (receiptState === 'missing' && attempt.rejectionMessage) {
          attempt.outcome = 'rejected';
          this.cartMessage = attempt.rejectionMessage;
        } else {
          // An empty read cannot rule out a timed-out POST finishing later.
          attempt.outcome = receiptState === 'partial' ? 'partial' : 'unknown';
        }
      } catch (error) {
        console.warn('[package-builder] Could not confirm the current cart:', error);
        if (!attempt.submitted) {
          attempt.outcome = 'rejected';
          this.cartMessage = this.dataset.errorLabel;
        }
      } finally {
        document.removeEventListener('shopify:cart:lines-update', handleCartActivity);
        attempt.inFlight = false;
        this.saveCartAttempt();
        this.renderCartAttempt();
        for (const peer of document.querySelectorAll('package-builder-real')) {
          if (peer !== this && peer.cartAttempt === attempt) peer.renderCartAttempt();
        }
        const errorMessage = this.querySelector('[data-package-cart-status]')?.textContent || '';
        const detail = {
          items: cart?.items, itemCount: cart?.item_count,
          source: 'package-builder-real', sourceId: this.id,
          didError: attempt.outcome !== 'complete',
          outcomeAmbiguous: !['complete', 'rejected'].includes(attempt.outcome),
          errorMessage: attempt.outcome === 'complete' ? undefined : errorMessage,
        };
        if (deferred) {
          try {
            deferred.resolve({ cart: cart ? events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) : null, detail });
          } catch {
            deferred.resolve({ cart: null, detail: { ...detail, didError: true } });
          }
        }
        if (cart && (!deferred || attempt.overlapped)) {
          // Recovery publishes a read, not another Add event or mutation.
          const components = Array.from(document.querySelectorAll('cart-items-component'));
          for (const component of components) {
            if (typeof component.reconcileCartData === 'function') {
              void component.reconcileCartData(cart).catch((error) => console.warn('[package-builder] Cart view refresh failed:', error));
            }
          }
          if (components.length === 0) {
            for (const icon of document.querySelectorAll('cart-icon')) {
              if (typeof icon.renderCartBubble === 'function') void icon.renderCartBubble(cart.item_count, false);
            }
          }
        }
        this.announce(errorMessage);
        if (!recovering && attempt.submitted && attempt.outcome === 'unknown') {
          // A server can finish after the client timeout. One later check is still read-only.
          setTimeout(() => {
            if (this.cartAttempt === attempt && !attempt.inFlight && this.isCartAttemptLocked()) {
              void this.addPackageToCart();
            }
          }, 1500);
        }
      }
    }

    announce(message) {
      const region = this.querySelector('[data-package-live-region]');
      if (region) region.textContent = message;
    }
  }

  if (!customElements.get('package-builder-real')) {
    customElements.define('package-builder-real', RealPackageBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-airport-pickup-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const AIRPORTS = [
      {
        group: 'Lower 48',
        regions: [
          { name: 'Alabama', items: [['BHM', 'Birmingham']] },
          { name: 'Arizona', items: [['PHX', 'Phoenix']] },
          { name: 'Arkansas', items: [['LIT', 'Little Rock']] },
          { name: 'California', items: [['FAT', 'Fresno'], ['LAX', 'Los Angeles'], ['ONT', 'Ontario'], ['SNA', 'Orange County'], ['SMF', 'Sacramento'], ['SAN', 'San Diego'], ['SFO', 'San Francisco']] },
          { name: 'Colorado', items: [['DEN', 'Denver']] },
          { name: 'Delaware', items: [['ILG', 'Wilmington']] },
          { name: 'Florida', items: [['FLL', 'Fort Lauderdale'], ['JAX', 'Jacksonville'], ['MIA', 'Miami'], ['MCO', 'Orlando'], ['PNS', 'Pensacola'], ['TPA', 'Tampa']] },
          { name: 'Georgia', items: [['ATL', 'Atlanta']] },
          { name: 'Idaho', items: [['BOI', 'Boise']] },
          { name: 'Illinois', items: [['ORD', 'Chicago']] },
          { name: 'Indiana', items: [['IND', 'Indianapolis']] },
          { name: 'Kansas', items: [['MCI', 'Kansas City']] },
          { name: 'Kentucky', items: [['SDF', 'Louisville']] },
          { name: 'Louisiana', items: [['BTR', 'Baton Rouge'], ['MSY', 'New Orleans']] },
          { name: 'Maryland', items: [['BWI', 'Baltimore']] },
          { name: 'Massachusetts', items: [['BOS', 'Boston']] },
          { name: 'Michigan', items: [['DTW', 'Detroit'], ['GRR', 'Grand Rapids']] },
          { name: 'Minnesota', items: [['MSP', 'Minneapolis']] },
          { name: 'Missouri', items: [['STL', 'St. Louis']] },
          { name: 'Montana', items: [['BIL', 'Billings']] },
          { name: 'Nebraska', items: [['OMA', 'Omaha']] },
          { name: 'Nevada', items: [['LAS', 'Las Vegas']] },
          { name: 'New Jersey', items: [['EWR', 'Newark']] },
          { name: 'New Mexico', items: [['ABQ', 'Albuquerque']] },
          { name: 'New York', items: [['BUF', 'Buffalo'], ['JFK', 'JFK (NYC)'], ['LGA', 'LaGuardia (NYC)']] },
          { name: 'North Carolina', items: [['CLT', 'Charlotte'], ['RDU', 'Raleigh-Durham']] },
          { name: 'Ohio', items: [['CVG', 'Cincinnati'], ['CLE', 'Cleveland'], ['CMH', 'Columbus']] },
          { name: 'Oklahoma', items: [['OKC', 'Oklahoma City']] },
          { name: 'Oregon', items: [['PDX', 'Portland']] },
          { name: 'Pennsylvania', items: [['PHL', 'Philadelphia'], ['PIT', 'Pittsburgh']] },
          { name: 'South Carolina', items: [['CHS', 'Charleston']] },
          { name: 'Tennessee', items: [['MEM', 'Memphis'], ['BNA', 'Nashville']] },
          { name: 'Texas', items: [['AUS', 'Austin'], ['DFW', 'Dallas/Fort Worth'], ['IAH', 'Houston'], ['SAT', 'San Antonio']] },
          { name: 'Utah', items: [['SLC', 'Salt Lake City']] },
          { name: 'Washington', items: [['SEA', 'Seattle']] },
          { name: 'Washington DC', items: [['DCA', 'Reagan National']] },
          { name: 'Wisconsin', items: [['MKE', 'Milwaukee']] },
        ],
      },
      {
        group: 'Hawaii / PR / AK',
        regions: [
          { name: 'Hawaii', items: [['HNL', 'Honolulu (Oahu)'], ['OGG', 'Kahului (Maui)'], ['KOA', 'Kona (Big Island)'], ['LIH', 'Lihue (Kauai)']] },
          { name: 'Puerto Rico', items: [['SJU', 'San Juan']] },
          { name: 'Alaska', items: [['ANC', 'Anchorage'], ['KTN', 'Ketchikan']] },
        ],
      },
      {
        group: 'International',
        regions: [
          { name: 'Canada', items: [['YUL', 'Montreal'], ['YYZ', 'Toronto'], ['YVR', 'Vancouver']] },
          { name: 'Caribbean & LatAm', items: [['STT', 'St. Thomas'], ['SDQ', 'Santo Domingo'], ['SAL', 'San Salvador'], ['PTY', 'Panama City'], ['SJO', 'San Jose (CR)'], ['LIM', 'Lima'], ['SCL', 'Santiago'], ['GRU', 'Sao Paulo']] },
          { name: 'Asia & Pacific', items: [['HND', 'Tokyo (Haneda)'], ['NRT', 'Tokyo (Narita)'], ['KIX', 'Osaka'], ['NGO', 'Nagoya'], ['TPE', 'Taipei'], ['SYD', 'Sydney'], ['MEL', 'Melbourne']] },
          { name: 'Europe', items: [['KEF', 'Reykjavik'], ['DUB', 'Dublin'], ['LHR', 'London'], ['EDI', 'Edinburgh'], ['AMS', 'Amsterdam'], ['CDG', 'Paris'], ['MRS', 'Marseille'], ['MAD', 'Madrid'], ['LIS', 'Lisbon'], ['FRA', 'Frankfurt'], ['MUC', 'Munich'], ['BER', 'Berlin'], ['FCO', 'Rome'], ['ATH', 'Athens']] },
        ],
      },
    ];

    const escapeHTML = (value) => String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

    const airportTotal = AIRPORTS.reduce(
      (total, group) => total + group.regions.reduce((regionTotal, region) => regionTotal + region.items.length, 0),
      0
    );

    function regionMarkup(region) {
      const airports = region.items.map(([code, city]) => (
        `<li><span class="rap-airport-code">${escapeHTML(code)}</span><span>${escapeHTML(city)}</span></li>`
      )).join('');

      return `<section class="rap-directory__region"><h4>${escapeHTML(region.name)}</h4><ul>${airports}</ul></section>`;
    }

    function groupMarkup(group, searchResults = false) {
      const count = group.regions.reduce((total, region) => total + region.items.length, 0);
      const countLabel = searchResults
        ? (count === 1 ? 'match' : 'matches')
        : (count === 1 ? 'airport' : 'airports');
      return `<section class="rap-directory__group">
        <header class="rap-directory__group-heading">
          <h3>${escapeHTML(group.group)}</h3>
          <span>${count} ${countLabel}</span>
        </header>
        <div class="rap-directory__regions">${group.regions.map(regionMarkup).join('')}</div>
      </section>`;
    }

    function renderDirectory(root, query = '') {
      const directory = root.querySelector('[data-airport-directory]');
      const count = root.querySelector('[data-airport-search-count]');
      if (!directory) return;

      const normalized = query.trim().toLowerCase();
      if (!normalized) {
        directory.innerHTML = AIRPORTS.map((group) => groupMarkup(group)).join('');
        if (count) count.hidden = true;
        return;
      }

      const matches = AIRPORTS.map((group) => {
        const regions = group.regions.map((region) => {
          const regionMatches = region.name.toLowerCase().includes(normalized);
          const items = region.items.filter(([code, city]) => (
            regionMatches || code.toLowerCase().includes(normalized) || city.toLowerCase().includes(normalized)
          ));
          return { name: region.name, items };
        }).filter((region) => region.items.length);
        return { group: group.group, regions };
      }).filter((group) => group.regions.length);

      const matchTotal = matches.reduce(
        (total, group) => total + group.regions.reduce((regionTotal, region) => regionTotal + region.items.length, 0),
        0
      );

      if (matchTotal) {
        directory.innerHTML = matches.map((group) => groupMarkup(group, true)).join('');
      } else {
        const email = escapeHTML(root.dataset.contactEmail || 'realpro@realwatersports.com');
        directory.innerHTML = `<div class="rap-directory__empty">
          <strong>No airports match &ldquo;${escapeHTML(query)}&rdquo;.</strong>
          <span>Try a nearby major airport, city, state, or three-letter airport code.</span>
          <span>Still don&rsquo;t see it? <a href="mailto:${email}">Email a REAL Pro</a>.</span>
        </div>`;
      }

      if (count) {
        count.textContent = `${matchTotal} ${matchTotal === 1 ? 'match' : 'matches'}`;
        count.hidden = false;
      }
    }

    function initialize(root) {
      if (root.dataset.airportPickupInitialized === 'true') return;
      root.dataset.airportPickupInitialized = 'true';

      root.querySelectorAll('[data-airport-count]').forEach((element) => {
        element.textContent = `${airportTotal} airports`;
      });
      root.querySelectorAll('[data-airport-total]').forEach((element) => {
        element.textContent = airportTotal;
      });

      const marquee = root.querySelector('[data-airport-marquee]');
      if (marquee) {
        const items = AIRPORTS.flatMap((group) => group.regions.flatMap((region) => region.items));
        const markup = items.map(([code, city]) => (
          `<span class="rap-marquee__item"><span class="rap-airport-code">${escapeHTML(code)}</span>${escapeHTML(city)}<span>&middot;</span></span>`
        )).join('');
        marquee.innerHTML = markup + markup;
      }

      const search = root.querySelector('[data-airport-search]');
      renderDirectory(root);
      if (search) {
        search.addEventListener('input', () => renderDirectory(root, search.value));
        search.addEventListener('search', () => renderDirectory(root, search.value));
      }
    }

    function initializeAll(scope = document) {
      if (scope.matches?.('[data-airport-pickup]')) initialize(scope);
      scope.querySelectorAll?.('[data-airport-pickup]').forEach(initialize);
    }

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-featured-navigation"] && !Shopify.designMode) return;
  try {
    
  class RealFeaturedNavigation extends HTMLElement {
    connectedCallback() {
      this.directoryToggleButton = this.querySelector('[data-real-featured-toggle]');
      this.directory = this.querySelector('[data-real-featured-directory]');
      this.directoryHeading = this.querySelector('[data-real-featured-directory-heading]');
      this.directoryContent = this.querySelector('.real-featured-navigation__directory');
      this.directoryMobileSlot = this.querySelector('[data-real-featured-mobile-directory]');
      this.directoryDesktopSlot = this.querySelector('.real-featured-navigation__content-inner');
      this.directoryToggleDesktopSlot = this.querySelector(
        '.real-featured-navigation__panel--one .real-featured-navigation__panel-header'
      );
      this.discoveryToggleButton = this.querySelector('[data-real-featured-discovery-toggle]');
      this.discoveryCloseButton = this.querySelector('[data-real-featured-discovery-close]');
      this.discoveryContent = this.querySelector('[data-real-featured-content]');
      this.discovery = this.querySelector('[data-real-featured-disclosure]');
      this.sharedHeadingTwo = this.querySelector('[data-real-featured-shared-heading-two]');
      this.panelTwoHeading = this.querySelector('[data-real-featured-panel-heading="two"]');

      this.handleDirectoryToggle = this.handleDirectoryToggle.bind(this);
      this.handleDiscoveryToggle = this.handleDiscoveryToggle.bind(this);
      this.handleDiscoveryClose = this.handleDiscoveryClose.bind(this);
      this.handleCollectionUpdate = this.handleCollectionUpdate.bind(this);
      this.handlePopState = this.handlePopState.bind(this);
      this.updateDirectoryHeight = this.updateDirectoryHeight.bind(this);
      this.updateDirectoryPlacement = this.updateDirectoryPlacement.bind(this);
      this.updateSharedHeadingOffset = this.updateSharedHeadingOffset.bind(this);

      this.directoryToggleButton?.addEventListener('click', this.handleDirectoryToggle);
      this.discoveryToggleButton?.addEventListener('click', this.handleDiscoveryToggle);
      this.discoveryCloseButton?.addEventListener('click', this.handleDiscoveryClose);
      document.addEventListener('shopify:collection:update', this.handleCollectionUpdate);
      window.addEventListener('popstate', this.handlePopState);

      if (this.discoveryCloseButton) this.discoveryCloseButton.hidden = false;

      if (this.directoryMobileSlot) {
        this.mobileLayoutQuery = window.matchMedia('(max-width: 899px)');
        this.mobileLayoutQuery.addEventListener('change', this.updateDirectoryPlacement);
        this.updateDirectoryPlacement();
      }

      if (this.directoryContent && 'ResizeObserver' in window) {
        this.directoryResizeObserver = new ResizeObserver(this.updateDirectoryHeight);
        this.directoryResizeObserver.observe(this.directoryContent);
      }

      if (this.sharedHeadingTwo && this.panelTwoHeading && 'ResizeObserver' in window) {
        this.headingResizeObserver = new ResizeObserver(this.updateSharedHeadingOffset);
        this.headingResizeObserver.observe(this);
      }

      this.headingLayoutFrame = requestAnimationFrame(this.updateSharedHeadingOffset);
      this.updateDirectoryHeight();
      document.fonts?.ready.then(() => {
        if (!this.isConnected) return;

        this.updateDirectoryHeight();
        this.updateSharedHeadingOffset();
      });

      this.currentFilterSignature = this.getFilterSignature();
      this.setDiscoveryExpanded(this.discovery.open);
    }

    disconnectedCallback() {
      this.discoveryTransition = (this.discoveryTransition || 0) + 1;
      this.directoryToggleButton?.removeEventListener('click', this.handleDirectoryToggle);
      this.discoveryToggleButton?.removeEventListener('click', this.handleDiscoveryToggle);
      this.discoveryCloseButton?.removeEventListener('click', this.handleDiscoveryClose);
      document.removeEventListener('shopify:collection:update', this.handleCollectionUpdate);
      window.removeEventListener('popstate', this.handlePopState);
      this.mobileLayoutQuery?.removeEventListener('change', this.updateDirectoryPlacement);
      this.directoryResizeObserver?.disconnect();
      this.headingResizeObserver?.disconnect();
      cancelAnimationFrame(this.headingLayoutFrame);
    }

    handleDirectoryToggle(event) {
      if (!this.directoryToggleButton || !this.directory) return;

      const expanded = this.directoryToggleButton.getAttribute('aria-expanded') !== 'true';

      this.updateDirectoryHeight();
      this.directoryToggleButton.setAttribute('aria-expanded', String(expanded));
      this.dataset.expanded = String(expanded);
      this.directory.dataset.expanded = String(expanded);
      this.directory.setAttribute('aria-hidden', String(!expanded));
      this.directory.inert = !expanded;

      // Mobile opens below the button; keep its position and keyboard focus stable.
      if (!expanded || !this.directoryHeading || this.mobileLayoutQuery?.matches) return;

      requestAnimationFrame(() => {
        this.directoryHeading.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });

        if (event.detail === 0) this.directoryHeading.focus({ preventScroll: true });
      });
    }

    handleDiscoveryToggle(event) {
      if (!this.discoveryToggleButton) return;

      event.preventDefault();
      const expanded = this.discoveryToggleButton.getAttribute('aria-expanded') !== 'true';
      this.setDiscoveryExpanded(expanded);
      if (event.detail === 0) this.discoveryCloseButton?.focus();
    }

    handleDiscoveryClose(event) {
      this.setDiscoveryExpanded(false);
      if (event.detail === 0) this.discoveryToggleButton?.focus();
    }

    handleCollectionUpdate() {
      this.syncFilterState();
    }

    handlePopState() {
      this.syncFilterState();
    }

    updateDirectoryPlacement() {
      if (!this.directoryMobileSlot || !this.directoryToggleButton || !this.directory) return;

      const mobile = this.mobileLayoutQuery.matches;
      const toggleParent = mobile ? this.directoryMobileSlot : this.directoryToggleDesktopSlot;
      const directoryParent = mobile ? this.directoryMobileSlot : this.directoryDesktopSlot;
      const activeElement = document.activeElement;
      const restoreFocus = activeElement === this.directoryToggleButton || this.directory.contains(activeElement);

      // Move the existing nodes so there is one control, one directory, and a matching tab order.
      if (this.directoryToggleButton.parentElement !== toggleParent) {
        toggleParent.append(this.directoryToggleButton);
      }
      if (this.directory.parentElement !== directoryParent) {
        if (mobile) directoryParent.append(this.directory);
        else directoryParent.prepend(this.directory);
      }

      this.dataset.directoryBelow = String(mobile);
      if (restoreFocus) activeElement.focus({ preventScroll: true });
      this.updateDirectoryHeight();
      this.updateSharedHeadingOffset();
    }

    updateDirectoryHeight() {
      if (!this.directoryContent) return;

      const directoryHeight = Math.ceil(
        Math.max(
          this.directoryContent.scrollHeight,
          this.directoryContent.getBoundingClientRect().height
        )
      );

      this.style.setProperty(
        '--real-featured-directory-height',
        `${directoryHeight}px`
      );
    }

    updateSharedHeadingOffset() {
      if (!this.sharedHeadingTwo || !this.panelTwoHeading) return;

      if (!window.matchMedia('(min-width: 900px)').matches) {
        this.dataset.headingsReady = 'false';
        this.style.removeProperty('--real-featured-model-heading-shift');
        return;
      }

      const sharedHeadingContainerPosition = this.sharedHeadingTwo.parentElement.getBoundingClientRect();
      const panelHeadingPosition = this.panelTwoHeading.getBoundingClientRect();

      if (sharedHeadingContainerPosition.width === 0 || panelHeadingPosition.width === 0) return;

      const sharedHeadingLeft = sharedHeadingContainerPosition.left + this.sharedHeadingTwo.offsetLeft;
      const headingShift = panelHeadingPosition.left - sharedHeadingLeft;
      this.style.setProperty('--real-featured-model-heading-shift', `${headingShift}px`);
      this.dataset.headingsReady = 'true';
    }

    getFilterSignature() {
      const activeFilters = [];

      for (const [name, value] of new URLSearchParams(window.location.search)) {
        if (!name.startsWith('filter.') || !value || name === 'filter.v.availability') continue;

        activeFilters.push(`${name}=${value}`);
      }

      return activeFilters.sort().join('&');
    }

    syncFilterState() {
      if (!this.discoveryToggleButton || !this.discoveryContent) return;

      const nextFilterSignature = this.getFilterSignature();
      const filtersChanged = nextFilterSignature !== this.currentFilterSignature;
      const filtersActive = nextFilterSignature !== '';

      this.currentFilterSignature = nextFilterSignature;
      this.dataset.filterActive = String(filtersActive);

      if (filtersChanged) {
        this.setDiscoveryExpanded(this.dataset.startCollapsed !== 'true' && !filtersActive);
      }
    }

    setDiscoveryExpanded(expanded) {
      if (!this.discoveryToggleButton || !this.discoveryContent) return;

      const transition = (this.discoveryTransition || 0) + 1;
      this.discoveryTransition = transition;
      this.dataset.discoveryExpanded = String(expanded);

      // Native details must remain open until desktop's visual collapse finishes.
      // Initial closed markup and mobile still close immediately; reopening cancels the pending close.
      if (!expanded && this.discovery.open && window.matchMedia('(min-width: 900px)').matches) {
        const animations = this.discoveryContent.getAnimations();
        if (animations.length) {
          Promise.allSettled(animations.map((animation) => animation.finished)).then(() => {
            if (this.isConnected && this.discoveryTransition === transition) this.discovery.open = false;
          });
        } else {
          this.discovery.open = false;
        }
      } else {
        this.discovery.open = expanded;
      }

      this.discoveryToggleButton.setAttribute('aria-label', this.discoveryToggleButton.dataset.openLabel);
      this.discoveryToggleButton.setAttribute('aria-expanded', String(expanded));
      this.discoveryToggleButton.setAttribute('aria-hidden', String(expanded));
      this.discoveryToggleButton.tabIndex = expanded ? -1 : 0;
      this.discoveryContent.setAttribute('aria-hidden', String(!expanded));
      this.discoveryContent.inert = !expanded;
      this.discoveryCloseButton?.setAttribute('aria-hidden', String(!expanded));
      if (this.discoveryCloseButton) this.discoveryCloseButton.tabIndex = expanded ? 0 : -1;
    }
  }

  if (!customElements.get('real-featured-navigation')) {
    customElements.define('real-featured-navigation', RealFeaturedNavigation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-featured-promo"] && !Shopify.designMode) return;
  try {
    
  class RealFeaturedPromoMedia extends HTMLElement {
    #observer;

    connectedCallback() {
      this.#setupViewportAutoplay();
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }

    async #setupViewportAutoplay() {
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      await customElements.whenDefined('deferred-media');

      if (!this.isConnected || this.#observer) return;

      const media = this.querySelector('deferred-media[data-deferred-autoplay]');
      if (!media) return;

      this.#observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry) return;

          if (entry.isIntersecting) {
            if (media.hasAttribute('data-media-loaded')) {
              media.playMedia();
            } else {
              media.loadContent(false);
              media.isPlaying = true;
              media.updatePlayPauseHint(true);
            }
          } else if (media.hasAttribute('data-media-loaded')) {
            media.pauseMedia();
          }
        },
        {
          rootMargin: '100px 0px',
          threshold: 0.01,
        }
      );

      this.#observer.observe(this);
    }
  }

  if (!customElements.get('real-featured-promo-media')) {
    customElements.define('real-featured-promo-media', RealFeaturedPromoMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-multi-collection-products"] && !Shopify.designMode) return;
  try {
    
  class RealCollectionProductTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.tabs = Array.from(this.querySelectorAll('[data-collection-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-collection-panel]'));
      this.tablist = this.querySelector('[data-tablist]');
      this.viewAll = this.querySelector('[data-view-all]');
      this.viewAllCollection = this.querySelector('[data-view-all-collection]');

      if (!this.tablist || this.tabs.length < 2 || this.tabs.length !== this.panels.length) return;

      this.initialized = true;
      this.activeIndex = Math.max(
        0,
        this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')
      );
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);

      this.addEventListener('click', this.handleClick);
      this.tablist.addEventListener('keydown', this.handleKeydown);
      this.syncViewAll(this.tabs[this.activeIndex]);
    }

    disconnectedCallback() {
      this.initialized = false;
      this.removeEventListener('click', this.handleClick);
      this.tablist?.removeEventListener('keydown', this.handleKeydown);
    }

    handleClick(event) {
      const tab = event.target.closest('[data-collection-tab]');
      if (!tab || !this.contains(tab)) return;

      this.selectTab(this.tabs.indexOf(tab));
    }

    handleKeydown(event) {
      const tab = event.target.closest('[data-collection-tab]');
      if (!tab || !this.tablist.contains(tab)) return;

      const currentIndex = this.tabs.indexOf(tab);
      const isRtl = getComputedStyle(this).direction === 'rtl';
      let nextIndex = null;

      if (event.key === 'ArrowRight') {
        nextIndex = isRtl ? currentIndex - 1 : currentIndex + 1;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = isRtl ? currentIndex + 1 : currentIndex - 1;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      }

      if (nextIndex == null) return;

      event.preventDefault();
      nextIndex = (nextIndex + this.tabs.length) % this.tabs.length;
      this.selectTab(nextIndex, { focus: true });
    }

    selectTab(index, { focus = false } = {}) {
      if (index < 0 || index >= this.tabs.length) return;

      if (index === this.activeIndex) {
        if (focus) this.tabs[index].focus({ preventScroll: true });
        return;
      }

      const previousTab = this.tabs[this.activeIndex];
      const previousPanel = this.panels[this.activeIndex];
      const nextTab = this.tabs[index];
      const nextPanel = this.panels[index];

      previousTab?.setAttribute('aria-selected', 'false');
      previousTab?.setAttribute('tabindex', '-1');
      if (previousPanel) previousPanel.hidden = true;

      nextTab.setAttribute('aria-selected', 'true');
      nextTab.setAttribute('tabindex', '0');
      nextPanel.hidden = false;
      this.activeIndex = index;
      this.syncViewAll(nextTab);

      if (focus) nextTab.focus({ preventScroll: true });
      nextTab.scrollIntoView({
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    }

    syncViewAll(tab) {
      if (!this.viewAll || !tab) return;

      const collectionUrl = tab.dataset.collectionUrl;
      const collectionLabel = tab.dataset.collectionLabel;
      const viewAllLabel = this.viewAll.dataset.viewAllLabel || this.viewAll.textContent.trim();
      const viewAllText = `${viewAllLabel} ${collectionLabel}`.trim();

      if (collectionUrl) this.viewAll.href = collectionUrl;
      if (this.viewAllCollection) this.viewAllCollection.textContent = collectionLabel;
      this.viewAll.setAttribute('aria-label', viewAllText);
    }
  }

  if (!customElements.get('real-collection-product-tabs')) {
    customElements.define('real-collection-product-tabs', RealCollectionProductTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-review-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.realReviewReady === 'true') return;

      const dataElement = root.querySelector('[data-real-review-data]');
      if (!dataElement) return;

      let data;
      try {
        data = JSON.parse(dataElement.textContent);
      } catch {
        return;
      }

      root.dataset.realReviewReady = 'true';

      const videos = data.videos.map((video) => {
        const localMetadata = data.metadata[video.id.toLowerCase()] || {};
        return {
          ...video,
          ...localMetadata,
          title: localMetadata.title || video.title,
          author: localMetadata.author || video.author
        };
      });

      const labels = data.labels;
      const stage = root.querySelector('[data-video-stage]');
      const facade = root.querySelector('[data-video-play]');
      const poster = root.querySelector('[data-video-poster]');
      const sidebar = root.querySelector('[data-video-sidebar]');
      const metaContainer = root.querySelector('[data-video-meta]');
      const summaryElement = root.querySelector('[data-video-summary]');
      const transcriptElement = root.querySelector('[data-video-transcript]');
      const statusElement = root.querySelector('[data-video-status]');
      const headerTitle = root.querySelector('[data-video-header-title]');
      const headerSubtitle = root.querySelector('[data-video-header-subtitle]');
      const theaterView = root.querySelector('[data-theater-view]');
      const galleryView = root.querySelector('[data-gallery-view]');
      const galleryGrid = root.querySelector('[data-gallery-grid]');
      const galleryToggle = root.querySelector('[data-gallery-toggle]');
      let currentIndex = 0;
      let isPlaying = false;
      let galleryRendered = false;

      const thumbnailUrl = (id, size = 'mqdefault') => `https://i.ytimg.com/vi/${id}/${size}.jpg`;

      const currentVideo = () => videos[currentIndex];

      const isRealWatersportsVideo = (video) => {
        const author = video.author?.trim().toLowerCase().replace(/\s+/g, ' ');
        return author === 'real watersports' || author === '@realwatersports';
      };

      const updateHeader = () => {
        const isRealReview = isRealWatersportsVideo(currentVideo());
        headerTitle.textContent = isRealReview ? labels.realHeading : labels.genericHeading;
        headerSubtitle.textContent = isRealReview ? labels.realSubheading : labels.genericSubheading;
      };

      const updateCards = () => {
        root.querySelectorAll('[data-video-select]').forEach((button) => {
          const index = Number(button.dataset.videoIndex);
          const video = videos[index];
          const selected = index === currentIndex;
          const title = button.querySelector('[data-video-title]');
          const author = button.querySelector('[data-video-author]');
          const state = button.querySelector('[data-video-state]');

          button.classList.toggle('is-selected', selected);
          if (selected) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }

          if (title) title.textContent = video.title;
          if (author) {
            author.textContent = video.author || '';
            author.hidden = !video.author;
          }
          if (state) {
            state.textContent = isPlaying && selected ? labels.nowPlaying : labels.selected;
            state.hidden = !selected;
          }
        });
      };

      const updateMeta = () => {
        const video = currentVideo();
        const hasSummary = Boolean(video.summary);
        const hasTranscript = Boolean(video.transcript);

        metaContainer.hidden = !hasSummary && !hasTranscript;
        summaryElement.innerHTML = hasSummary ? `<h3>${labels.about}</h3>${video.summary}` : '';
        transcriptElement.innerHTML = hasTranscript
          ? `<details><summary>${labels.transcript}</summary><div class="real-video__transcript-content"><div class="real-video__transcript-note">${labels.transcriptNote}</div>${video.transcript}</div></details>`
          : '';
      };

      const applyPosterFallback = () => {
        if (poster.dataset.fallbackApplied === 'true') return;
        poster.dataset.fallbackApplied = 'true';
        poster.src = thumbnailUrl(poster.dataset.videoId, 'hqdefault');
      };

      const validatePoster = () => {
        if (poster.dataset.fallbackApplied === 'true') return;

        // YouTube serves a 120x90 gray placeholder when maxresdefault is unavailable.
        if (poster.naturalWidth <= 120 || poster.naturalHeight <= 90) applyPosterFallback();
      };

      const updateFacade = () => {
        const video = currentVideo();
        facade.href = `https://www.youtube.com/watch?v=${video.id}`;
        facade.setAttribute('aria-label', `${labels.play}: ${video.title}`);
        poster.dataset.fallbackApplied = 'false';
        poster.dataset.videoId = video.id;
        poster.src = thumbnailUrl(video.id, 'maxresdefault');
        if (poster.complete) validatePoster();
      };

      const resetPlayer = () => {
        const frame = stage.querySelector('iframe');
        if (frame) frame.remove();
        facade.hidden = false;
        isPlaying = false;
      };

      const selectVideo = (index, announce = true) => {
        if (!videos[index]) return;
        if (index !== currentIndex) resetPlayer();
        currentIndex = index;
        updateFacade();
        updateHeader();
        updateMeta();
        updateCards();

        if (announce) {
          statusElement.textContent = `${currentVideo().title} ${labels.selectedStatus}`;
        }
      };

      const playVideo = () => {
        const video = currentVideo();
        const frame = document.createElement('iframe');
        frame.src = `https://www.youtube.com/embed/${video.id}?autoplay=1&rel=0`;
        frame.title = video.title;
        frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.allowFullscreen = true;
        facade.hidden = true;
        stage.append(frame);
        isPlaying = true;
        updateCards();
      };

      const createGallery = () => {
        if (!galleryGrid || galleryRendered) return;

        const fragment = document.createDocumentFragment();
        videos.forEach((video, index) => {
          const button = document.createElement('button');
          const thumbnail = document.createElement('span');
          const image = document.createElement('img');
          const info = document.createElement('span');
          const title = document.createElement('span');
          const author = document.createElement('span');
          const state = document.createElement('span');

          button.type = 'button';
          button.className = `real-video__gallery-card${index === currentIndex ? ' is-selected' : ''}`;
          button.dataset.videoSelect = '';
          button.dataset.videoIndex = String(index);
          if (index === currentIndex) button.setAttribute('aria-current', 'true');

          thumbnail.className = 'real-video__gallery-thumbnail';
          image.src = thumbnailUrl(video.id);
          image.width = 320;
          image.height = 180;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.alt = '';
          thumbnail.append(image);

          info.className = 'real-video__gallery-info';
          title.className = 'real-video__card-title';
          title.dataset.videoTitle = '';
          title.textContent = video.title;
          author.className = 'real-video__card-author';
          author.dataset.videoAuthor = '';
          author.textContent = video.author || '';
          author.hidden = !video.author;
          state.className = 'real-video__state';
          state.dataset.videoState = '';
          state.textContent = labels.selected;
          state.hidden = index !== currentIndex;
          info.append(title, author, state);

          button.append(thumbnail, info);
          fragment.append(button);
        });

        galleryGrid.append(fragment);
        galleryRendered = true;
      };

      const setGalleryMode = (showGallery) => {
        if (!galleryToggle || !galleryView) return;
        if (showGallery) resetPlayer();
        if (showGallery) createGallery();

        theaterView.hidden = showGallery;
        galleryView.hidden = !showGallery;
        galleryToggle.setAttribute('aria-pressed', String(showGallery));
        galleryToggle.querySelector('[data-gallery-label]').textContent = showGallery ? labels.theater : labels.gallery;
        galleryToggle.querySelector('[data-gallery-icon]').hidden = showGallery;
        galleryToggle.querySelector('[data-theater-icon]').hidden = !showGallery;
        updateCards();
      };

      const readCache = (id) => {
        try {
          return JSON.parse(sessionStorage.getItem(`real-review:${id}`));
        } catch {
          return null;
        }
      };

      const writeCache = (id, metadata) => {
        try {
          sessionStorage.setItem(`real-review:${id}`, JSON.stringify(metadata));
        } catch {
          return;
        }
      };

      const fetchMetadata = async (video) => {
        const hasResolvedTitle = video.title && !/^Video \d+$/.test(video.title);
        if (hasResolvedTitle && video.author) return;

        const cached = readCache(video.id);
        if (cached) {
          video.title = cached.title || video.title;
          video.author = cached.author || video.author;
          if (video.title && !/^Video \d+$/.test(video.title) && video.author) return;
        }

        try {
          const watchUrl = `https://www.youtube.com/watch?v=${video.id}`;
          const response = await fetch(`https://noembed.com/embed?url=${encodeURIComponent(watchUrl)}`);
          if (!response.ok) return;
          const metadata = await response.json();
          video.title = metadata.title || video.title;
          video.author = metadata.author_name || video.author;
          writeCache(video.id, { title: video.title, author: video.author });
        } catch {
          return;
        }
      };

      const hydrateMetadata = async () => {
        await Promise.all(videos.map(fetchMetadata));
        updateCards();
        updateHeader();
        updateMeta();
        facade.setAttribute('aria-label', `${labels.play}: ${currentVideo().title}`);
        const frame = stage.querySelector('iframe');
        if (frame) frame.title = currentVideo().title;
      };

      root.addEventListener('click', (event) => {
        const playLink = event.target.closest('[data-video-play]');
        if (playLink) {
          event.preventDefault();
          playVideo();
          return;
        }

        const selection = event.target.closest('[data-video-select]');
        if (selection) {
          const wasGallery = galleryView && !galleryView.hidden;
          selectVideo(Number(selection.dataset.videoIndex));
          if (wasGallery) {
            setGalleryMode(false);
            requestAnimationFrame(() => facade.focus());
          }
          return;
        }

        const toggle = event.target.closest('[data-gallery-toggle]');
        if (toggle) {
          setGalleryMode(toggle.getAttribute('aria-pressed') !== 'true');
        }
      });

      poster.addEventListener('load', validatePoster);
      poster.addEventListener('error', applyPosterFallback);

      if (sidebar && 'ResizeObserver' in window) {
        const syncSidebar = () => {
          sidebar.style.maxHeight = window.matchMedia('(max-width: 900px)').matches
            ? ''
            : `${stage.getBoundingClientRect().height}px`;
        };
        const resizeObserver = new ResizeObserver(syncSidebar);
        resizeObserver.observe(stage);
        syncSidebar();
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          hydrateMetadata();
        }, { rootMargin: '400px 0px' });
        observer.observe(root);
      } else {
        hydrateMetadata();
      }

      selectVideo(0, false);
    };

    const initializeAll = (scope = document) => {
      if (scope.matches?.('[data-real-review]')) initialize(scope);
      scope.querySelectorAll?.('[data-real-review]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-stoke-hub"] && !Shopify.designMode) return;
  try {
    
  class RealStokeHub extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.abortController = new AbortController();
      this.layers = Array.from(this.querySelectorAll('[data-stoke-layer]'));
      this.tabs = Array.from(this.querySelectorAll('[data-stoke-tab]'));
      this.panel = this.querySelector('[data-stoke-panel]');
      this.heading = this.querySelector('[data-stoke-heading]');
      this.description = this.querySelector('[data-stoke-text]');
      this.button = this.querySelector('[data-stoke-button]');
      this.status = this.querySelector('[data-stoke-status]');
      this.mobileMedia = window.matchMedia('(max-width: 768px)');
      this.preloadCache = new Map();
      this.activeLayer = this.layers.find((layer) => layer.classList.contains('is-active')) || this.layers[0];
      this.activeTab = this.tabs.find((tab) => tab.classList.contains('is-active')) || this.tabs[0];
      this.requestId = 0;

      if (!this.activeLayer || !this.activeTab || !this.panel) return;

      const signal = this.abortController.signal;

      this.addEventListener('pointerover', (event) => this.handleWarmEvent(event), { passive: true, signal });
      this.addEventListener('focusin', (event) => this.handleWarmEvent(event), { signal });
      this.addEventListener('click', (event) => this.handleClick(event), { signal });
      this.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      document.addEventListener('shopify:block:select', (event) => this.handleBlockSelect(event), { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.initialized = false;
    }

    tabFromEvent(event) {
      const tab = event.target.closest('[data-stoke-tab]');
      return tab && this.contains(tab) ? tab : null;
    }

    handleWarmEvent(event) {
      const tab = this.tabFromEvent(event);
      if (tab) this.warmTab(tab).catch(() => {});
    }

    handleClick(event) {
      const tab = this.tabFromEvent(event);
      if (tab) this.activateTab(tab);
    }

    handleKeydown(event) {
      const tab = this.tabFromEvent(event);
      if (!tab) return;

      const index = this.tabs.indexOf(tab);

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.focusTab(index + 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.focusTab(index - 1);
      } else if (event.key === 'Home') {
        event.preventDefault();
        this.focusTab(0);
      } else if (event.key === 'End') {
        event.preventDefault();
        this.focusTab(this.tabs.length - 1);
      }
    }

    handleBlockSelect(event) {
      const tab = this.tabFromEvent(event);
      if (!tab) return;

      tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      this.activateTab(tab);
    }

    getImageUrl(tab) {
      const sources = this.getImageSources(tab);
      return (this.mobileMedia.matches ? sources.mobile : sources.desktop).src;
    }

    getImageSources(tab) {
      const desktop = {
        src: tab.dataset.desktopImage || '',
        srcset: tab.dataset.desktopSrcset || '',
        sizes: tab.dataset.desktopSizes || '100vw',
      };
      const mobile = {
        src: tab.dataset.mobileImage || '',
        srcset: tab.dataset.mobileSrcset || '',
        sizes: tab.dataset.mobileSizes || '100vw',
      };
      return {
        desktop: desktop.src ? desktop : mobile,
        mobile: mobile.src ? mobile : desktop,
      };
    }

    preloadImage(source) {
      if (!source.src) return Promise.resolve(null);
      const cacheKey = JSON.stringify([
        source.src, source.srcset, source.sizes, window.innerWidth, window.devicePixelRatio,
      ]);
      if (this.preloadCache.has(cacheKey)) return this.preloadCache.get(cacheKey);

      const promise = new Promise((resolve, reject) => {
        const preload = new Image();
        preload.decoding = 'async';
        preload.onload = () => {
          if (typeof preload.decode === 'function') {
            preload
              .decode()
              .catch(() => {})
              .then(() => resolve(preload));
          } else {
            resolve(preload);
          }
        };
        preload.onerror = reject;
        preload.sizes = source.sizes;
        preload.srcset = source.srcset;
        preload.src = source.src;
      });

      this.preloadCache.set(cacheKey, promise);
      promise.catch(() => this.preloadCache.delete(cacheKey));
      return promise;
    }

    warmTab(tab) {
      const sources = this.getImageSources(tab);
      return this.preloadImage(this.mobileMedia.matches ? sources.mobile : sources.desktop);
    }

    async waitForImage(image) {
      if (typeof image.decode === 'function') {
        try {
          await image.decode();
          if (image.naturalWidth > 0) return;
        } catch (error) {
          void error;
        }
      }

      if (image.complete && image.naturalWidth > 0) return;

      await new Promise((resolve, reject) => {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', reject, { once: true });
      });
    }

    async loadLayer(layer, tab) {
      const source = layer.querySelector('source');
      const image = layer.querySelector('img');
      const { desktop, mobile } = this.getImageSources(tab);

      if (!image || !desktop.src) return false;

      if (source) {
        source.sizes = mobile.sizes;
        source.srcset = mobile.srcset || mobile.src;
      }
      image.sizes = desktop.sizes;
      image.srcset = desktop.srcset;
      image.src = desktop.src;
      await this.waitForImage(image);
      return true;
    }

    updateTabs(selectedTab) {
      this.tabs.forEach((tab) => {
        const selected = tab === selectedTab;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });
    }

    updateContent(tab) {
      this.heading.textContent = tab.dataset.heading || '';
      this.description.textContent = tab.dataset.description || '';

      const buttonLabel = tab.dataset.buttonLabel || '';
      const buttonLink = tab.dataset.buttonLink || '';
      const showButton = Boolean(buttonLabel && buttonLink);

      this.button.textContent = buttonLabel;
      this.button.hidden = !showButton;

      if (showButton) {
        this.button.setAttribute('href', buttonLink);
      } else {
        this.button.removeAttribute('href');
      }

      this.panel.setAttribute('aria-labelledby', tab.id);
    }

    updateStatus(tab) {
      const label = tab.querySelector('span')?.textContent.trim() || '';
      const suffix = this.dataset.selectionStatus || '';
      this.status.textContent = suffix ? `${label} ${suffix}` : label;
    }

    async activateTab(tab) {
      if (tab === this.activeTab) {
        this.requestId += 1;
        this.panel.setAttribute('aria-busy', 'false');
        return;
      }

      const currentRequest = ++this.requestId;
      const nextLayer = this.layers.find((layer) => layer !== this.activeLayer);
      const imageUrl = this.getImageUrl(tab);

      this.panel.setAttribute('aria-busy', 'true');

      try {
        if (imageUrl && nextLayer) {
          await this.warmTab(tab);
          if (currentRequest !== this.requestId) return;

          const loaded = await this.loadLayer(nextLayer, tab);
          if (currentRequest !== this.requestId) return;

          if (loaded) {
            nextLayer.classList.add('is-active');
            this.activeLayer.classList.remove('is-active');
            this.activeLayer = nextLayer;
          }
        }

        this.updateContent(tab);
        this.updateTabs(tab);
        this.updateStatus(tab);
        this.activeTab = tab;
      } catch (error) {
        if (currentRequest === this.requestId) this.status.textContent = '';
      } finally {
        if (currentRequest === this.requestId) this.panel.setAttribute('aria-busy', 'false');
      }
    }

    focusTab(index) {
      const nextTab = this.tabs[(index + this.tabs.length) % this.tabs.length];
      nextTab.focus();
      nextTab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      this.warmTab(nextTab).catch(() => {});
      this.activateTab(nextTab);
    }
  }

  if (!customElements.get('real-stoke-hub')) {
    customElements.define('real-stoke-hub', RealStokeHub);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["surfboard-brand-models"]) return;
  try {
    
  if (!customElements.get('surfboard-brand-models')) {
    customElements.define(
      'surfboard-brand-models',
      class SurfboardBrandModels extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.handleClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
        }

        handleClick(event) {
          const toggle = event.target.closest('[data-subcollections-toggle]');

          if (!toggle || !this.contains(toggle)) return;

          const wrapper = toggle.closest('.subcollections-grid-wrapper');
          if (!wrapper) return;

          const expanded = toggle.getAttribute('aria-expanded') !== 'true';
          const showLabel = toggle.querySelector('[data-subcollections-label-show]');
          const hideLabel = toggle.querySelector('[data-subcollections-label-hide]');

          wrapper.classList.toggle('is-collapsed', !expanded);
          wrapper.classList.toggle('is-expanded', expanded);
          toggle.setAttribute('aria-expanded', String(expanded));

          if (showLabel) showLabel.hidden = expanded;
          if (hideLabel) hideLabel.hidden = !expanded;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["surfboard-model-alerts"]) return;
  try {
    
  const initializeSurfboardModelAlert = (root) => {
    if (root.dataset.initialized === 'true') return;

    const target = document.querySelector('.surfboard-model-v2 .surfboard-model-content');
    const dialog = root.querySelector('[data-model-alert-dialog]');
    const openButton = root.querySelector('[data-model-alert-open]');
    const closeButton = root.querySelector('[data-model-alert-close]');
    const form = root.querySelector('[data-model-alert-form]');
    const submitButton = root.querySelector('[data-model-alert-submit]');
    const status = root.querySelector('[data-model-alert-status]');
    const emailInput = form?.querySelector('input[name="email"]');

    if (
      !target ||
      !dialog ||
      !openButton ||
      !closeButton ||
      !form ||
      !submitButton ||
      !status ||
      !emailInput
    )
      return;

    const rememberedEmailKey = 'real:follow-shape:email';

    const getRememberedEmail = () => {
      try {
        return window.sessionStorage.getItem(rememberedEmailKey) || '';
      } catch (_error) {
        return '';
      }
    };

    const rememberEmail = (email) => {
      try {
        window.sessionStorage.setItem(rememberedEmailKey, email);
      } catch (_error) {
        // Browsers can block session storage; the form still works without it.
      }
    };

    if (!emailInput.value) {
      emailInput.value = getRememberedEmail();
    }

    root.dataset.initialized = 'true';
    target.classList.add('has-surfboard-model-alert');
    const heading = target.querySelector(':scope > .surfboard-model-heading');
    const reviewBadge = heading?.querySelector(':scope > small');
    const mobileActions = document.createElement('div');
    const mobileQuery = window.matchMedia('(max-width: 750px)');

    mobileActions.className = 'surfboard-model-heading-actions';

    const placeAlert = (isMobile) => {
      if (!heading) {
        target.prepend(root);
        return;
      }

      if (isMobile) {
        heading.insertAdjacentElement('afterend', mobileActions);
        if (reviewBadge) mobileActions.append(reviewBadge);
        mobileActions.append(root);
        return;
      }

      if (reviewBadge) heading.append(reviewBadge);
      heading.insertAdjacentElement('afterend', root);
      mobileActions.remove();
    };

    placeAlert(mobileQuery.matches);

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', (event) => placeAlert(event.matches));
    } else {
      mobileQuery.addListener((event) => placeAlert(event.matches));
    }

    root.hidden = false;

    const setStatus = (message = '', state = '') => {
      status.textContent = message;

      if (state) {
        status.dataset.state = state;
      } else {
        delete status.dataset.state;
      }
    };

    const openDialog = () => {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    };

    const closeDialog = () => {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };

    openButton.addEventListener('click', openDialog);
    closeButton.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;

      const bounds = dialog.getBoundingClientRect();
      const clickedOutside =
        event.clientX < bounds.left ||
        event.clientX > bounds.right ||
        event.clientY < bounds.top ||
        event.clientY > bounds.bottom;

      if (clickedOutside) closeDialog();
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const formData = new FormData(form);
      const email = String(formData.get('email') || '').trim();
      const honeypot = String(formData.get('website') || '').trim();

      if (honeypot) {
        setStatus(root.dataset.successMessage, 'success');
        return;
      }

      if (!email || !form.reportValidity()) return;

      submitButton.disabled = true;
      submitButton.textContent = root.dataset.submittingLabel;
      setStatus();

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'REAL surfboard model collection alert',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  meta: {
                    patch_properties: {
                      append: {
                        real_surfboard_model_collection_gids: root.dataset.collectionGid
                      }
                    }
                  },
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: root.dataset.listId
              }
            }
          }
        }
      };

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(root.dataset.companyId)}`,
          {
            method: 'POST',
            headers: {
              accept: 'application/vnd.api+json',
              'content-type': 'application/vnd.api+json',
              revision: '2026-07-15'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) throw new Error(`Klaviyo subscription failed with status ${response.status}`);

        rememberEmail(email);

        if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
          const identifyRequest = window.klaviyo.identify({ email });
          identifyRequest?.catch(() => {});
        }

        form.reset();
        form.querySelectorAll('input, button').forEach((control) => {
          control.disabled = true;
        });
        submitButton.textContent = root.dataset.submitLabel;
        setStatus(root.dataset.successMessage, 'success');
        openButton.querySelector('span').textContent = root.dataset.requestedLabel;
      } catch (error) {
        console.error(error);
        submitButton.disabled = false;
        submitButton.textContent = root.dataset.submitLabel;
        setStatus(root.dataset.errorMessage, 'error');
      }
    });
  };

  document.querySelectorAll('[data-surfboard-model-alert]').forEach(initializeSurfboardModelAlert);

  } catch(e) { console.error(e); }
})();
})();
